import Clappr, { Browser, Utils as Utils$1, template, $ as $$1, Events as Events$1, Playback, Log as Log$1, HTML5Video, ContainerPlugin, Loader } from '@clappr/core';
import HLSJS from 'hls.js';
import shaka from 'shaka-player';

var global$1 = (typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};

function noop() {}

var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance$1 = global$1.performance || {};
var performanceNow =
  performance$1.now        ||
  performance$1.mozNow     ||
  performance$1.msNow      ||
  performance$1.oNow       ||
  performance$1.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance$1)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var process = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/* eslint-disable */

/**
 * Object.assign
 * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
 *
 * Original source : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    // length of function is 2.
    value: function assign(target, varArgs) {

      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }

      return to;
    },
    writable: true,
    configurable: true
  });
}
/**
 * Array.prototype.includes
 *
 * Original source : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
 * See also : https://tc39.github.io/ecma262/#sec-array.prototype.includes
 */


if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(searchElement, fromIndex) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this); // 2. Let len be ? ToLength(? Get(O, "length")).

      var len = o.length >>> 0; // 3. If len is 0, return false.

      if (len === 0) {
        return false;
      } // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)


      var n = fromIndex | 0; // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.

      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0); // 7. Repeat, while k < len

      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        // NOTE: === provides the correct "SameValueZero" comparison needed here.
        if (o[k] === searchElement) {
          return true;
        }

        k++;
      } // 8. Return false


      return false;
    }
  });
} // Math.trunc polyfill (IE11 support)


Math.trunc = Math.trunc || function (x) {
  return x < 0 ? Math.ceil(x) : Math.floor(x);
};
/*
  startsWith polyfill (IE11 support)
  https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
*/


if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

var Uid = /*#__PURE__*/function () {
  function Uid() {
    _classCallCheck(this, Uid);
  }

  _createClass(Uid, null, [{
    key: "s4",
    value: function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
  }, {
    key: "generate",
    value: function generate() {
      return "".concat(this.s4() + this.s4(), "-").concat(this.s4(), "-").concat(this.s4(), "-").concat(this.s4(), "-").concat(this.s4()).concat(this.s4()).concat(this.s4());
    }
  }]);

  return Uid;
}();

/**
 * Converts the time value from a Date object to a Unix timestmap.
 * @param {Date} date a Date object to be converted
 * @returns {number} a Unix timestamp with the converted value or NaN if conversion is not possible
 */

var getUnixTimestamp = function getUnixTimestamp(date) {
  return date && typeof date.getTime === 'function' ? Math.trunc(date.getTime() / 1000) : NaN;
};
/**
 * Returns a Unix timestamp with the seconds (and sub-second) value truncated to 0.
 * @param {number} time a Unix timestamp representing the time to be truncated
 */

var truncateTimeSeconds = function truncateTimeSeconds(time) {
  var date = new Date(time * 1000);
  date.setSeconds(0, 0);
  return getUnixTimestamp(date);
};
var isTimestampOnHashNeeded = !Browser.isChrome && !Browser.isChromecast && !Browser.isSmartTvEnvironment;

var Environment = /*#__PURE__*/function () {
  _createClass(Environment, null, [{
    key: "isInternal",
    get: function get() {
      return /(ef(-.*)?|publish\.api\.video|player)(\.qa01|\.local|\.dev)?\.globoi\.com$/.test(location.hostname);
    }
  }, {
    key: "isLocalhost",
    get: function get() {
      return ['localhost', '127.0.0.1'].includes(location.hostname);
    }
  }, {
    key: "isGloboiDomain",
    get: function get() {
      return /\.globoi\.com$/.test(location.hostname);
    }
  }, {
    key: "isGloboDomain",
    get: function get() {
      return !this.isInternal && /\.globo\.com$/.test(location.hostname);
    }
  }, {
    key: "playerId",
    get: function get() {
      if (!this._playerId) this._playerId = Uid.generate();
      return this._playerId;
    }
  }, {
    key: "hashQueryString",
    get: function get() {
      var resourceId = 'resource_id=<%= resourceId %>';
      var callback = '<%= callback ? \'&callback=\' + callback : \'\' %>'; // eslint-disable-line no-useless-escape

      var version = "&version=".concat("1.18.1-resource-renew");
      var player = '&player=<%= player %>';
      var timezone = '&tz=<%= tz %>';
      var CDN = '&cdn=<%= cdn %>';
      var profile = '&profile=<%= profile %>';
      var flatUrl = '<% if (flatUrl) { %>&flat_url=true<% } %>';
      var queryStringItems = "hash?".concat(resourceId).concat(callback).concat(version).concat(player).concat(timezone).concat(CDN).concat(profile).concat(flatUrl);
      isTimestampOnHashNeeded && (queryStringItems += '&ts=<%= ts %>');
      return queryStringItems;
    }
  }]);

  function Environment(httpOnly) {
    var customEnv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Environment);

    this.httpOnly = httpOnly;
    this.protocol = "http".concat(httpOnly ? '' : 's');
    this.customEnv = customEnv;
  }

  _createClass(Environment, [{
    key: "blackVideoUrl",
    get: function get() {
      return "".concat(this.protocol, "://s3.glbimg.com/v1/AUTH_e1b09a2d222b4900a437a46914be81e5/static/black.mp4");
    }
  }, {
    key: "blackVideoStreamingUrl",
    get: function get() {
      return "".concat(this.protocol, "://s3.glbimg.com/v1/AUTH_e1b09a2d222b4900a437a46914be81e5/static/black.m3u8");
    }
  }, {
    key: "blackDashUrl",
    get: function get() {
      return "".concat(this.protocol, "://s3.glbimg.com/v1/AUTH_e1b09a2d222b4900a437a46914be81e5/static/black.mpd");
    }
  }], [{
    key: "get",
    value: function get(name, httpOnly, customEnv) {
      name === 'qa1' ? name = 'dev' : name; // eslint-disable-line

      name = Environment.isInternal ? name === 'dev' ? 'internalDev' : 'internal' : name || 'prod'; // eslint-disable-line

      return new Environment[name](httpOnly, customEnv);
    }
  }]);

  return Environment;
}();
Environment.local = Utils$1.extend(Environment, {
  get name() {
    return 'local';
  },

  get securityHost() {
    return "".concat(this.protocol, "://security.video.globo.com");
  },

  get CDNRouterHost() {
    return "".concat(this.protocol, "://playback.video.globo.com/v2/video-session");
  },

  get CDNRouterFallbackHost() {
    return "".concat(this.protocol, "://playback2.video.globo.com/v2/video-session");
  },

  get hashTemplate() {
    return template("".concat(this.protocol, "://security.video.globo.com/videos/<%= videoId %>/").concat(Environment.hashQueryString));
  },

  get playlistTemplate() {
    return template("".concat(this.protocol, "://api.globovideos.com/videos/<%= videoId %>/").concat(this.httpOnly ? 'insecure_playlist' : 'playlist', "/without_resources/callback/<%= callback %>"));
  },

  get posterTemplate() {
    return template("".concat(this.protocol, "://s0<%= domainNumber %>.video.glbimg.com/<%= size %>/<%= videoId %>.jpg"));
  }

});
Environment.dev = Utils$1.extend(Environment, {
  get name() {
    return 'dev';
  },

  get securityHost() {
    return "".concat(this.protocol, "://security.video.dev.globoi.com");
  },

  get CDNRouterHost() {
    return "".concat(this.protocol, "://playback.video.dev.globoi.com/v2/video-session");
  },

  get CDNRouterFallbackHost() {
    return "".concat(this.protocol, "://playback.video.dev.globoi.com/v2/video-session");
  },

  get hashTemplate() {
    return template("".concat(this.protocol, "://security.video.dev.globoi.com/videos/<%= videoId %>/").concat(Environment.hashQueryString));
  },

  get playlistTemplate() {
    return template("".concat(this.protocol, "://api.globovideos.dev.globoi.com/videos/<%= videoId %>/").concat(this.httpOnly ? 'insecure_playlist' : 'playlist', "/without_resources/callback/<%= callback %>"));
  },

  get posterTemplate() {
    return template("".concat(this.protocol, "://s0<%= domainNumber %>.video.glbimg.dev.globoi.com/<%= size %>/<%= videoId %>.jpg"));
  }

});
Environment.internalDev = Utils$1.extend(Environment, {
  get name() {
    return 'internalDev';
  },

  get securityHost() {
    return "".concat(this.protocol, "://api.video.dev.globoi.com");
  },

  get CDNRouterHost() {
    return "".concat(this.protocol, "://internal.playback.video.dev.globoi.com/v2/video-session");
  },

  get CDNRouterFallbackHost() {
    return "".concat(this.protocol, "://internal.playback.video.dev.globoi.com/v2/video-session");
  },

  get hashTemplate() {
    return template("".concat(this.protocol, "://api.video.dev.globoi.com/videos/<%= videoId %>/").concat(Environment.hashQueryString));
  },

  get playlistTemplate() {
    return template("".concat(this.protocol, "://api.video.dev.globoi.com/videos/<%= videoId %>/").concat(this.httpOnly ? 'insecure_playlist' : 'playlist', "/without_resources/callback/<%= callback %>"));
  },

  get posterTemplate() {
    return template("".concat(this.protocol, "://s0<%= domainNumber %>.video.glbimg.dev.globoi.com/<%= size %>/<%= videoId %>.jpg"));
  }

});
Environment.internal = Utils$1.extend(Environment, {
  get name() {
    return 'internal';
  },

  get securityHost() {
    return "".concat(this.protocol, "://api.video.globoi.com");
  },

  get CDNRouterHost() {
    return "".concat(this.protocol, "://internal.playback.video.globoi.com/v2/video-session");
  },

  get CDNRouterFallbackHost() {
    return "".concat(this.protocol, "://internal.playback.video.globoi.com/v2/video-session");
  },

  get hashTemplate() {
    return template("".concat(this.protocol, "://api.video.globoi.com/videos/<%= videoId %>/").concat(Environment.hashQueryString));
  },

  get playlistTemplate() {
    return template("".concat(this.protocol, "://api.video.globoi.com/videos/<%= videoId %>/").concat(this.httpOnly ? 'insecure_playlist' : 'playlist', "/without_resources/callback/<%= callback %>"));
  },

  get posterTemplate() {
    return template("".concat(this.protocol, "://s0<%= domainNumber %>.video.glbimg.com/<%= size %>/<%= videoId %>.jpg"));
  }

});
Environment.prod = Utils$1.extend(Environment, {
  get name() {
    return 'prod';
  },

  get securityHost() {
    return "".concat(this.protocol, "://security.video.globo.com");
  },

  get CDNRouterHost() {
    return "".concat(this.protocol, "://playback.video.globo.com/v2/video-session");
  },

  get CDNRouterFallbackHost() {
    return "".concat(this.protocol, "://playback2.video.globo.com/v2/video-session");
  },

  get hashTemplate() {
    return template("".concat(this.protocol, "://security.video.globo.com/videos/<%= videoId %>/").concat(Environment.hashQueryString));
  },

  get playlistTemplate() {
    return template("".concat(this.protocol, "://api.globovideos.com/videos/<%= videoId %>/").concat(this.httpOnly ? 'insecure_playlist' : 'playlist', "/without_resources/callback/<%= callback %>"));
  },

  get posterTemplate() {
    return template("".concat(this.protocol, "://s0<%= domainNumber %>.video.glbimg.com/<%= size %>/<%= videoId %>.jpg"));
  }

});
Environment.custom = Utils$1.extend(Environment.prod, {
  get name() {
    return 'custom';
  },

  get CDNRouterHost() {
    return this.customEnv.CDNRouterHost || "".concat(this.protocol, "://playback.video.globo.com/v2/video-session");
  },

  get CDNRouterFallbackHost() {
    return this.customEnv.CDNRouterFallbackHost || "".concat(this.protocol, "://playback2.video.globo.com/v2/video-session");
  }

});

var zeroPad = function zeroPad(number, size) {
  var len = size + 1 - number.toString().length;
  return new Array(Math.max(0, len)).join('0') + number;
};
var HEX_TAB = '0123456789abcdef';
var B64_TAB = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
var b64pad = '';
var rstr2b64 = function rstr2b64(input) {
  var output = '';
  var len = input.length;

  for (var i = 0; i < len; i += 3) {
    var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);

    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += B64_TAB.charAt(triplet >>> 6 * (3 - j) & 0x3F);
    }
  }

  return output;
};
var rstr2hex = function rstr2hex(input) {
  var output = '';

  for (var i = 0; i < input.length; i++) {
    var x = input.charCodeAt(i);
    output += HEX_TAB.charAt(x >>> 4 & 0x0F) + HEX_TAB.charAt(x & 0x0F);
  }

  return output;
};

var getCurrentDate = function getCurrentDate() {
  return new Date();
};
var getCurrentTime = function getCurrentTime() {
  return getCurrentDate().getTime();
};
var get = function get(object, path, defaultResponse) {
  var everyFunc = function everyFunc(step) {
    return !(step && (object = object[step]) === undefined);
  }; // eslint-disable-line


  var fullPath = path.replace(/\[/g, '.').replace(/]/g, '').split('.').filter(Boolean);
  return fullPath.every(everyFunc) ? object : defaultResponse;
};
var toDurationString = function toDurationString(time) {
  var timeInMinutes = time / 60000;
  var durationRanges = [0, 1, 2, 3, 4, 5, 7, 10];
  var i;

  for (i = 0; i < durationRanges.length; i++) {
    if (timeInMinutes < durationRanges[i]) break;
  }

  if (i < durationRanges.length) return "".concat(zeroPad(durationRanges[i - 1], 2), ":0").concat(i === 0 ? 0 : 1, " - ").concat(zeroPad(durationRanges[i], 2), ":00");
  return '10:01 +';
};
var iso8601TimezoneOffset = function iso8601TimezoneOffset() {
  // timezone offset is positive for timezones behind UTC
  var offset = -getCurrentDate().getTimezoneOffset();
  var hours = Math.abs(offset) / 60;
  var minutes = Math.abs(offset) % 60;
  var sign = offset === 0 ? '' : offset > 0 ? '+' : '-';
  return "".concat(sign).concat(zeroPad(hours, 2), ":").concat(zeroPad(minutes, 2));
};
var getHostname = function getHostname() {
  return location.hostname;
};
var getHostAndPathName = function getHostAndPathName() {
  var pathName = location.pathname || '';
  var pathNameList = pathName.split('/') || [];
  return location.hostname + (pathNameList.length > 0 ? "/".concat(pathNameList[1]) : '');
};
var loadUrlAsImage = function loadUrlAsImage(url) {
  var img = new Image();
  img.src = url;
  return img;
};
var getCookie = function getCookie(cookieName) {
  var results = document.cookie.match("(^|;) ?".concat(cookieName, "=([^;]*)(;|$)"));
  if (results) return window.unescape(results[2]);
  return null;
};
var getExpiresDateInGMT = function getExpiresDateInGMT(days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date.toGMTString();
};
var applySizeClass = function applySizeClass(element, width) {
  if (!width || typeof width !== 'number') return;
  element.removeClass('w960 w640 w540 w480 w360');
  if (width <= 360) element.addClass('w360');else if (width <= 480) element.addClass('w480');else if (width < 540) element.addClass('w540');else if (width <= 640) element.addClass('w640');else element.addClass('w960');
};
var isNaN$1 = function isNaN(value) {
  return value !== value;
}; //eslint-disable-line

var secondsToMillis = function secondsToMillis(time) {
  return time * 1000 >> 0;
};
var percent = function percent(current, total) {
  return current === 0 ? current : current / total * 100;
};
var now = function now() {
  return window.performance && window.performance.now && performance.now() || Date.now();
};
var toLowerCase = function toLowerCase(str) {
  return typeof str === 'string' ? str.toLowerCase() : str;
};
var embedScript = function embedScript(url) {
  var deferred = $$1.Deferred(); //eslint-disable-line

  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = url;

  script.onload = function () {
    deferred.resolve();
  };

  script.onerror = function (e) {
    deferred.reject(e);
  };

  document.head.appendChild(script);
  return deferred.promise();
};
var copyToClipboard = function copyToClipboard(value, $el) {
  if (!$el) return;
  var $copyTextarea = $$1('<textarea style="opacity:0" class="copytextarea"/>');
  $copyTextarea.text(value);
  $el.append($copyTextarea[0]);
  var copyTextarea = $el.find('.copytextarea')[0]; //eslint-disable-line

  var currentFocus = document.activeElement;
  copyTextarea.focus();
  copyTextarea.select();
  var copied = document.execCommand('copy');
  $copyTextarea.remove();
  currentFocus.focus();
  return copied;
};
var mergePlugins = function mergePlugins(player, external) {
  var pluginsName = [];
  return player.concat(external).filter(function (plugin) {
    if (!plugin) return false;
    var name = plugin.prototype.name;
    var isNotExist = pluginsName.indexOf(name) === -1;
    if (isNotExist) pluginsName.push(name);
    return isNotExist;
  });
};
/* eslint-disable */

var PADDINGgrf = '=0xAC10FD';

var rstr_grf = function rstr_grf(s) {
  var str2rstr_utf8 = function str2rstr_utf8(input, padding) {
    var output = '';
    var i = -1;
    var x, y;
    input = input + padding.substr(1, 8);

    while (++i < input.length) {
      /* Decode utf-16 surrogate pairs */
      x = input.charCodeAt(i);
      y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;

      if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
        x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
        i++;
      }
      /* Encode output as utf-8 */


      if (x <= 0x7F) {
        output += String.fromCharCode(x);
      } else if (x <= 0x7FF) {
        output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);
      } else if (x <= 0xFFFF) {
        output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
      } else if (x <= 0x1FFFFF) {
        output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
      }
    }

    return output;
  };

  var rstr2binl = function rstr2binl(input) {
    var i,
        output = new Array(input.length >> 2);

    for (i = 0; i < output.length; i++) {
      output[i] = 0;
    }

    for (i = 0; i < input.length * 8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
    }

    return output;
  };

  var binl2rstr = function binl2rstr(input) {
    var output = '';

    for (var i = 0; i < input.length * 32; i += 8) {
      output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
    }

    return output;
  };

  var safe_add = function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  };

  var bit_rol = function bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  };

  var grf_cmn = function grf_cmn(q, a, b, x, s, t) {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
  };

  var grf_ff = function grf_ff(a, b, c, d, x, s, t) {
    return grf_cmn(b & c | ~b & d, a, b, x, s, t);
  };

  var grf_gg = function grf_gg(a, b, c, d, x, s, t) {
    return grf_cmn(b & d | c & ~d, a, b, x, s, t);
  };

  var grf_hh = function grf_hh(a, b, c, d, x, s, t) {
    return grf_cmn(b ^ c ^ d, a, b, x, s, t);
  };

  var grf_ii = function grf_ii(a, b, c, d, x, s, t) {
    return grf_cmn(c ^ (b | ~d), a, b, x, s, t);
  };

  var binl_grf = function binl_grf(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (var i = 0; i < x.length; i += 16) {
      var olda = a;
      var oldb = b;
      var oldc = c;
      var oldd = d;
      a = grf_ff(a, b, c, d, x[i + 0], 7, -680876936);
      d = grf_ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = grf_ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = grf_ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = grf_ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = grf_ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = grf_ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = grf_ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = grf_ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = grf_ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = grf_ff(c, d, a, b, x[i + 10], 17, -42063);
      b = grf_ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = grf_ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = grf_ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = grf_ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = grf_ff(b, c, d, a, x[i + 15], 22, 1236535329);
      a = grf_gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = grf_gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = grf_gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = grf_gg(b, c, d, a, x[i + 0], 20, -373897302);
      a = grf_gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = grf_gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = grf_gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = grf_gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = grf_gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = grf_gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = grf_gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = grf_gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = grf_gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = grf_gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = grf_gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = grf_gg(b, c, d, a, x[i + 12], 20, -1926607734);
      a = grf_hh(a, b, c, d, x[i + 5], 4, -378558);
      d = grf_hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = grf_hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = grf_hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = grf_hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = grf_hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = grf_hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = grf_hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = grf_hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = grf_hh(d, a, b, c, x[i + 0], 11, -358537222);
      c = grf_hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = grf_hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = grf_hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = grf_hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = grf_hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = grf_hh(b, c, d, a, x[i + 2], 23, -995338651);
      a = grf_ii(a, b, c, d, x[i + 0], 6, -198630844);
      d = grf_ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = grf_ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = grf_ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = grf_ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = grf_ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = grf_ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = grf_ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = grf_ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = grf_ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = grf_ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = grf_ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = grf_ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = grf_ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = grf_ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = grf_ii(b, c, d, a, x[i + 9], 21, -343485551);
      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
    }

    return [a, b, c, d];
  };

  var rstr_grf_impl = function rstr_grf_impl(s) {
    return binl2rstr(binl_grf(rstr2binl(s), s.length * 8));
  };

  return rstr_grf_impl(str2rstr_utf8(s, PADDINGgrf));
};

var hexGrf = function hexGrf(s) {
  return rstr2hex(rstr_grf(s));
};
var Miscellaneous = {
  applySizeClass: applySizeClass,
  toLowerCase: toLowerCase,
  embedScript: embedScript,
  get: get,
  getCookie: getCookie,
  getCurrentDate: getCurrentDate,
  getCurrentTime: getCurrentTime,
  getExpiresDateInGMT: getExpiresDateInGMT,
  getHostname: getHostname,
  getHostAndPathName: getHostAndPathName,
  isNaN: isNaN$1,
  iso8601TimezoneOffset: iso8601TimezoneOffset,
  loadUrlAsImage: loadUrlAsImage,
  now: now,
  percent: percent,
  toDurationString: toDurationString,
  secondsToMillis: secondsToMillis,
  copyToClipboard: copyToClipboard,
  mergePlugins: mergePlugins,
  hexGrf: hexGrf
};

var Ajax = {
  jsonp: function jsonp(settings) {
    var defer = new $$1.Deferred();
    settings.callbackName = settings.callbackName || 'json_callback';
    settings.timeout = settings.timeout || 15000;

    window[settings.callbackName] = function (data) {
      if (Ajax.isErrorObject(data)) defer.reject(data);else defer.resolve(data);
    };

    var head = $$1('head')[0]; //eslint-disable-line

    var script = document.createElement('script');
    script.setAttribute('src', settings.url);
    script.setAttribute('async', 'async');

    script.onload = script.onreadystatechange = function (eventLoad) {
      // eslint-disable-line
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {
        if (settings.timeoutId) window.clearTimeout(settings.timeoutId); // Handling memory leak in IE, removing and dereference the script

        script.onload = script.onreadystatechange = null; // eslint-disable-line

        if (head && script.parentNode) head.removeChild(script);
        script = undefined;
      }
    };

    script.onerror = function () {
      defer.reject({
        error: true,
        message: 'jsonp load error'
      });
    }; // Use insertBefore instead of appendChild to circumvent an IE6 bug.


    head.insertBefore(script, head.firstChild);
    if (settings.error) settings.timeoutId = window.setTimeout(settings.error, settings.timeout);
    return defer.promise();
  },
  isErrorObject: function isErrorObject(data) {
    return data && data.http_status_code && data.http_status_code !== 200;
  }
};

var Fullscreen = {
  // Move this method to Clappr core
  isFullscreen: function isFullscreen() {
    return document.webkitIsFullScreen || document.mozFullScreen;
  },
  requestFullscreen: function requestFullscreen(el) {
    if (el.requestFullscreen) el.requestFullscreen();else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();else if (el.mozRequestFullScreen) el.mozRequestFullScreen();else if (el.msRequestFullscreen) el.msRequestFullscreen();
  },
  cancelFullscreen: function cancelFullscreen() {
    if (document.exitFullscreen) document.exitFullscreen();else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();else if (document.mozCancelFullScreen) document.mozCancelFullScreen();else if (document.msExitFullscreen) document.msExitFullscreen();
  }
};

var GLOBALS = Browser.isSmartTvEnvironment ? ['google', '$YB'] : ['google', 'google.ima', '$YB'];
var registerGlobal = function registerGlobal(scriptMainObject) {
  GLOBALS.push(scriptMainObject);
};
var GlobalsManager = /*#__PURE__*/function () {
  function GlobalsManager() {
    _classCallCheck(this, GlobalsManager);

    this.loadScriptsIntervalId = null;
    this.loadScriptsAttempts = 5;
  }

  _createClass(GlobalsManager, [{
    key: "ready",
    value: function ready() {
      return !GLOBALS.filter(function (l) {
        return typeof get(window, l, undefined) === 'undefined';
      }).length;
    }
  }, {
    key: "isAvailable",
    value: function isAvailable() {
      var _this = this;

      var defer = new $$1.Deferred();
      this.loadScriptsIntervalId = setInterval(function () {
        if (_this.ready()) {
          clearInterval(_this.loadScriptsIntervalId);
          defer.resolve();
        } else {
          _this.loadScriptsAttempts--;
        }

        if (!_this.loadScriptsAttempts) {
          clearInterval(_this.loadScriptsIntervalId);
          defer.reject();
        }
      }, 200);
      return defer.promise();
    }
  }]);

  return GlobalsManager;
}();

var API_VERSION = window.WM && window.WM.version || 'legacy_api';
var getDeviceType = function getDeviceType() {
  if (Browser.isChromecast) return 'cast';
  if (Browser.isSmartTvEnvironment) return 'tv';
  if (Browser.isMobile) return 'mobile';
  return 'desktop';
};
var getPlatformName = function getPlatformName(playerType) {
  return "web-".concat(playerType);
};

var hasExperiments = function hasExperiments(options) {
  return _typeof(options.playerExperiments) === 'object';
};
var getSelectedExperiment = function getSelectedExperiment(options, experimentName) {
  return options.playerExperiments && options.playerExperiments[experimentName];
};
var getExperimentsList = function getExperimentsList() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!hasExperiments(options)) return [];
  var experiments = Object.keys(options.playerExperiments) || [];
  var experimentsList = experiments.map(function (alternative) {
    var experiment = options.playerExperiments[alternative];
    return experiment && experiment.alternative || '';
  }) || [];
  experimentsList = experimentsList.filter(function (alternative) {
    return alternative !== '';
  });
  return experimentsList;
};
var getExperimentAlternative = function getExperimentAlternative() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var experimentName = arguments.length > 1 ? arguments[1] : undefined;
  // eslint-disable-line default-param-last
  if (!hasExperiments(options)) return '';
  var selectedExperiment = getSelectedExperiment(options, experimentName);
  return selectedExperiment && selectedExperiment.alternative || '';
};

var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }

  _createClass(LocalStorage, null, [{
    key: "keyspaceFor",
    value: function keyspaceFor(key) {
      return "wm.player.".concat(key);
    }
  }, {
    key: "load",
    value: function load(key, parseFunction) {
      return this.loadRaw(this.keyspaceFor(key), parseFunction);
    }
  }, {
    key: "loadRaw",
    value: function loadRaw(key, parseFunction) {
      if (Browser.hasLocalstorage && localStorage[key]) return parseFunction ? parseFunction(localStorage[key]) : localStorage[key];
    }
  }, {
    key: "store",
    value: function store(key, value) {
      return this.storeRaw(this.keyspaceFor(key), value);
    }
  }, {
    key: "storeRaw",
    value: function storeRaw(key, value) {
      if (Browser.hasLocalstorage) try {
        localStorage[key] = value;
        return true;
      } catch (e) {
        return false;
      }
      return false;
    }
  }]);

  return LocalStorage;
}();

var DEFAULT_ERROR = {
  code: 'default-error',
  description: 'There was a problem trying to load the video.',
  reportAs: 'ERROR',
  internalError: true
};
var Errors = {
  DEFAULT_ERROR: DEFAULT_ERROR,
  AUTH_REQUIRED: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'login-required',
    description: 'Authentication required.',
    reportAs: 'INFO'
  }),
  DEVICE_NOT_AUTHORIZED: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'device-not-registered',
    description: 'Device needs register to play content.',
    reportAs: 'INFO'
  }),
  DEVICE_NOT_SUPPORTED: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'player-type-not-supported',
    description: 'Device not supported',
    reportAs: 'INFO'
  }),
  GEOFENCING: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'geo-fencing',
    description: 'This video cannot be played in the current location.',
    reportAs: 'INFO'
  }),
  GEO_BLOCKED: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'geo-block',
    description: 'This video cannot be played in the current region.',
    reportAs: 'INFO'
  }),
  HASH_LOAD_ERROR: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'security-load-error',
    description: 'Error loading hash.'
  }),
  PLAYER_NOT_RECOGNIZED: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'PNR',
    description: 'Player Not Recognized.'
  }),
  RESOURCE_LOAD_ERROR: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'resource-load-error',
    description: 'Error loading resource.'
  }),
  LOCATION_UNAVAILABLE: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'location-unavailable',
    description: 'Could not play content. Location is unavailable.',
    reportAs: 'INFO'
  }),
  NOT_ALLOWED_DOMAIN: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'not-allowed-domain',
    description: 'The video cannot be played on the current domain.',
    reportAs: 'INFO'
  }),
  NOT_FOUND: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'video-not-found',
    description: 'Content not available.',
    reportAs: 'INFO'
  }),
  PLAYLIST_LOAD_ERROR: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'playlist-load-error',
    description: 'Error loading video resources.'
  }),
  RESTRICTED_CONTENT: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'restricted-content-error',
    description: 'Restricted content.',
    reportAs: 'INFO'
  }),
  SIMULTANEOUS_ACCESS: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'simultaneous-access-exceeded',
    description: 'There are too much sessions currently active on the same account.',
    reportAs: 'INFO'
  }),
  STREAMING_PAUSE_TIME_EXPIRED: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'streaming-pause-time-expired',
    description: 'The video was paused for a long time.',
    reportAs: 'INFO'
  }),
  SUBSCRIBERS_ONLY: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'user-not-authorized',
    description: 'Exclusive content for subscribers.',
    reportAs: 'INFO'
  }),
  UNSUPPORTED_BROWSER: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'unsupported-browser',
    description: 'Browser not supported.',
    reportAs: 'INFO'
  }),
  UNSUPPORTED_MOBILE_DEVICE: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'unsupported-mobile-device',
    description: 'Mobile device not supported.',
    reportAs: 'INFO'
  }),
  TIMESTAMP_ERROR: _objectSpread2(_objectSpread2({}, DEFAULT_ERROR), {}, {
    code: 'timestamp-error',
    description: 'Timestamp error.',
    reportAs: 'INFO'
  })
};

var Location = /*#__PURE__*/function () {
  function Location() {
    _classCallCheck(this, Location);
  }

  _createClass(Location, null, [{
    key: "getLocation",
    value: function getLocation() {
      return new Promise(function (resolve, reject) {
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function (position) {
          resolve(position);
        }, function (error) {
          reject(_objectSpread2({
            error: error
          }, Errors.LOCATION_UNAVAILABLE));
        });else reject(Errors.LOCATION_UNAVAILABLE);
      });
    }
  }]);

  return Location;
}();

var QueryString = /*#__PURE__*/function () {
  function QueryString() {
    _classCallCheck(this, QueryString);
  }

  _createClass(QueryString, null, [{
    key: "params",
    get: function get() {
      var match;
      var pl = /\+/g; // Regex for replacing addition symbol with a space

      var search = /([^&=]+)=?([^&]*)/g;

      var decode = function decode(s) {
        return decodeURIComponent(s.replace(pl, ' '));
      };

      var query = window.location.search.substring(1);
      var urlParams = {};

      while (match = search.exec(query)) {
        // eslint-disable-line no-cond-assign
        urlParams[decode(match[1]).toLowerCase()] = decode(match[2]);
      }

      return urlParams;
    }
  }]);

  return QueryString;
}();
var toQueryString = function toQueryString() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var onlyValid = function onlyValid(k) {
    return params[k] || params[k] === '' || params[k] === 0;
  };

  var encode = encodeURIComponent;
  var keys = Object.keys(params);
  return keys.filter(onlyValid).map(function (k) {
    return "".concat(encode(k), "=").concat(encode(params[k]));
  }).join('&');
};
var seekStringToSeconds = function seekStringToSeconds() {
  var seconds = 0;
  var seekString = QueryString.params.s || '';
  var parts = seekString.match(/[0-9]+[hms]+/g) || [];

  if (parts.length > 0) {
    var factor = {
      h: 3600,
      m: 60,
      s: 1
    };
    parts.forEach(function (el) {
      if (el) {
        var suffix = el[el.length - 1];
        var time = parseInt(el.slice(0, el.length - 1), 10);
        seconds += time * factor[suffix];
      }
    });
  } else if (seekString) {
    seconds = parseInt(seekString, 10);
  }

  return seconds;
};

var User = /*#__PURE__*/function () {
  function User() {
    _classCallCheck(this, User);
  }

  _createClass(User, null, [{
    key: "getProviderCookieName",
    value: function getProviderCookieName(providerId) {
      return providerId ? "WMPTOKEN_".concat(providerId) : 'GLBID';
    }
  }, {
    key: "hasGlbId",
    value: function hasGlbId() {
      var glbid = getCookie('GLBID');
      return typeof glbid === 'string' && glbid.length > 10;
    }
  }, {
    key: "hasTokenForProvider",
    value: function hasTokenForProvider(providerId) {
      if (!providerId) return this.hasGlbId();
      var cookieName = this.getProviderCookieName(providerId);

      if (cookieName) {
        var cookie = getCookie(cookieName);
        return typeof cookie === 'string';
      }

      return false;
    }
  }, {
    key: "isExperimentEnabled",
    value: function isExperimentEnabled(name, ratio) {
      var key = "experiment.".concat(name);
      var userValue = LocalStorage.load(key, parseFloat);

      if (!userValue) {
        userValue = Math.random();
        LocalStorage.store(key, userValue);
      }

      return userValue <= ratio;
    }
  }, {
    key: "uid",
    get: function get() {
      var key = 'user.uid';
      var uid = LocalStorage.load(key);

      if (!uid) {
        uid = Uid.generate();
        LocalStorage.store(key, uid);
      }

      return uid;
    }
  }]);

  return User;
}();

var hasPlayerElement = function hasPlayerElement(element) {
  if (element && element.childNodes.length > 0) {
    var childNodesArray = Array.prototype.slice.call(element.childNodes);
    var tagElement = childNodesArray.find(function (element) {
      return element.tagName === 'DIV' && element.id.indexOf('wp3-player-') !== -1;
    });
    return tagElement && !!document.getElementById(tagElement.id);
  }

  return false;
};

var hasChildElement = function hasChildElement(parent) {
  var childSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!parent) return;
  var parentID = parent.id || typeof parent.attr === 'function' && parent.attr('id');
  var selector = "#".concat(parentID, " ").concat(childSelector);
  var hasChild = !!document.querySelectorAll(selector).length;
  return hasChild;
};

var isIframe = function isIframe() {
  return window.top !== window;
};

var DOM = {
  hasPlayerElement: hasPlayerElement,
  hasChildElement: hasChildElement,
  isIframe: isIframe
};

var Session = /*#__PURE__*/function () {
  function Session() {
    _classCallCheck(this, Session);

    this.sessions = {};
  }

  _createClass(Session, [{
    key: "startSession",
    value: function startSession(playerId) {
      if (!playerId) return;
      var lastSessionData = this.sessions[playerId] || {};
      this.sessions[playerId] = _objectSpread2(_objectSpread2({}, lastSessionData), {}, {
        sessionId: Uid.generate()
      });
    }
  }, {
    key: "getVideoSessionId",
    value: function getVideoSessionId(playerId) {
      if (!this.sessions[playerId]) return;
      return this.sessions[playerId].sessionId;
    }
  }, {
    key: "storeLockId",
    value: function storeLockId(playerId, lockId) {
      if (!this.sessions[playerId] || !lockId) return;
      this.sessions[playerId].lockId = lockId;
    }
  }, {
    key: "getLockId",
    value: function getLockId(playerId) {
      if (!this.sessions[playerId]) return;
      return this.sessions[playerId].lockId;
    }
  }]);

  return Session;
}();

var session = new Session();

/* eslint-disable */
var BLACK_WITH_SOUND_MP4 = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';

window.WM_PLAYER_VIDEO_TAG_TEST_AUDIO = document.createElement('video');
window.WM_PLAYER_VIDEO_TAG_TEST_MUTE = document.createElement('video');
var AUTOPLAY_DETECTION_TIMEOUT = 5000;

var AutoplayManager = /*#__PURE__*/function () {
  function AutoplayManager() {
    _classCallCheck(this, AutoplayManager);

    this._deferred = new $$1.Deferred();
    this.playerHasConsent = false;

    this._setBrowserFlags();
  }

  _createClass(AutoplayManager, [{
    key: "isAutoPlayMutedAllowed",
    value: function isAutoPlayMutedAllowed(options) {
      return this.isAvailable(true) && options.autoPlay;
    }
  }, {
    key: "allowAutoplay",
    value: function allowAutoplay(options) {
      return options.autoPlay && this.canAutoPlayMuted || Browser.isSmartTvEnvironment && options.autoPlay || Browser.isChromecast;
    }
  }, {
    key: "onAutoplayAvailable",
    value: function onAutoplayAvailable(callback, options, callbackFailed) {
      var _this = this;

      return this._deferred.then(function () {
        _this.allowAutoplay(options) ? callback() : callbackFailed === null || callbackFailed === void 0 ? void 0 : callbackFailed();
      });
    }
  }, {
    key: "isAvailable",
    value: function isAvailable(mute) {
      return this.playerHasConsent || this.isAllowedWithAudio || mute && this.isAllowedWithoutAudio;
    }
  }, {
    key: "consent",
    value: function consent() {
      this.playerHasConsent = true;
    }
  }, {
    key: "_setBrowserFlags",
    value: function _setBrowserFlags() {
      var _this2 = this;

      if (Browser.isSmartTvEnvironment || Browser.isChromecast) {
        this._deferred.resolve();

        return;
      }

      var videoWithAudio = this._createVideoElement(BLACK_WITH_SOUND_MP4, false);

      var videoWithoutAudio = this._createVideoElement(BLACK_WITH_SOUND_MP4, true);

      if (Browser.isMobile) this.isAllowedWithAudio = false;else this._setFlag(videoWithAudio, 'isAllowedWithAudio');

      this._setFlag(videoWithoutAudio, 'isAllowedWithoutAudio');

      setTimeout(function () {
        return _this2._deferred.resolve();
      }, AUTOPLAY_DETECTION_TIMEOUT);
    }
  }, {
    key: "_setFlag",
    value: function _setFlag(videoElement, attribute) {
      var _this3 = this;

      var promise = videoElement.play();

      if (promise) {
        promise.then(function () {
          _this3[attribute] = true;
        }, function () {
          _this3[attribute] = false;
        }).then(function () {
          return _this3._resolve();
        });
      } else {
        this[attribute] = !Browser.isMobile;

        this._resolve();
      }
    }
  }, {
    key: "_resolve",
    value: function _resolve() {
      var isFlagsDefined = 'isAllowedWithAudio' in this && 'isAllowedWithoutAudio' in this;
      if (isFlagsDefined) this._deferred.resolve();
    }
  }, {
    key: "_createVideoElement",
    value: function _createVideoElement(source, muted) {
      var video = muted ? window.WM_PLAYER_VIDEO_TAG_TEST_MUTE : window.WM_PLAYER_VIDEO_TAG_TEST_AUDIO;
      video.src = source;
      video.muted = muted;
      video.playsInline = true;
      return video;
    }
  }, {
    key: "canAutoPlayMuted",
    get: function get() {
      return this.isAvailable(true);
    }
  }, {
    key: "canAutoPlayUnmuted",
    get: function get() {
      return this.isAvailable(false);
    }
  }]);

  return AutoplayManager;
}();

var autoplayManager = new AutoplayManager();

var convertToString = function convertToString(obj) {
  try {
    if (_typeof(obj) === 'object') return JSON.stringify(obj);
  } catch (e) {} // eslint-disable-line


  return obj;
};

var recoverableErrorChecks = {
  html5_video: function html5_video(error) {
    //eslint-disable-line
    return error.raw.code === error.raw.MEDIA_ERR_NETWORK;
  },
  hls_fairplay_playback: function hls_fairplay_playback(error) {
    //eslint-disable-line
    return error.raw.code === error.raw.MEDIA_ERR_NETWORK;
  },
  hls: function hls(error) {
    switch (error.raw.type) {
      case HLSJS.ErrorTypes.NETWORK_ERROR:
        switch (error.raw.details) {
          case HLSJS.ErrorDetails.MANIFEST_LOAD_ERROR:
          case HLSJS.ErrorDetails.LEVEL_LOAD_ERROR:
          case HLSJS.ErrorDetails.FRAG_LOAD_ERROR:
          case HLSJS.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            {
              var response = error.raw.response;
              return !(response.code >= 400 && response.code < 500);
            }

          case HLSJS.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
          case HLSJS.ErrorDetails.LEVEL_LOAD_TIMEOUT:
          case HLSJS.ErrorDetails.FRAG_LOAD_TIMEOUT:
          case HLSJS.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            return true;

          default:
            return false;
        }

      default:
        return false;
    }
  },
  dash_shaka_playback: function dash_shaka_playback(error) {
    //eslint-disable-line
    var code = error.raw.code || error.raw.detail && error.raw.detail.code;
    var data = error.raw.data || error.raw.detail && error.raw.detail.data;

    switch (code) {
      case shaka.util.Error.Code.BAD_HTTP_STATUS:
        {
          // https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
          var _data = _slicedToArray(data, 2),
              statusCode = _data[1];

          return !(statusCode >= 400 && statusCode < 500);
        }

      case shaka.util.Error.Code.HTTP_ERROR:
      case shaka.util.Error.Code.TIMEOUT:
        return true;

      default:
        return false;
    }
  }
};
var checkRecoverableError = function checkRecoverableError(playbackName, playbackError) {
  return recoverableErrorChecks[playbackName] && recoverableErrorChecks[playbackName](playbackError);
};

/**
 * Returns a Unix timestamp representation from a given playback position.
 * @param {number} position the current position in seconds
 * @param {Date} startTime the DateTime corresponding to the start time
 * @returns {number} the Unix timestamp corresponding to the position
 */
var getTimeFromPosition = function getTimeFromPosition(position, startTime) {
  return startTime && typeof startTime.getTime === 'function' ? Math.trunc(startTime.getTime() / 1000 + position) : NaN;
}; // eslint-disable-line

/**
 * Returns the current time as a Unix timestamp corresponding to the
 * current position of a given playback.
 * @param {HLS, DashShakaPlayback} playback the playback to be used (must be a HLS or DashShakaPlayback)
 * @returns {number} the Unix timestamp corresponding to the current position
 */

var getCurrentTime$1 = function getCurrentTime(playback) {
  var position = playback.getCurrentTime();
  var startTime = playback.getProgramDateTime ? new Date(playback.getProgramDateTime()) : null;
  return getTimeFromPosition(position, startTime);
};
/**
 * Returns the difference (offset) between the provided time and the current playback time.
 * @param {HLS, DashShakaPlayback} playback the playback to be used (must be a HLS or DashShakaPlayback)
 * @param {Date} time the DateTime corresponding to a given time in seconds
 * @returns {number} the value corresponding to the difference between the current time and the given time
 */

var getLiveDifferenceFromTime = function getLiveDifferenceFromTime(playback, time) {
  return getCurrentTime$1(playback) - time;
};
/**
 * Returns the playback position from a Unix timestamp.
 * @param {HLS, DashShakaPlayback} playback the playback to be used (must be a HLS or DashShakaPlayback)
 * @param {Date} time the DateTime corresponding to the desired position in seconds
 * @returns {number} the position corresponding to the provided Unix timestamp
 */

var getPositionFromTime = function getPositionFromTime(playback, time) {
  return playback.getCurrentTime() - getLiveDifferenceFromTime(playback, time);
};

var Utils = _objectSpread2(_objectSpread2({}, Miscellaneous), {}, {
  Ajax: Ajax,
  getExperimentsList: getExperimentsList,
  getExperimentAlternative: getExperimentAlternative,
  Fullscreen: Fullscreen,
  getDeviceType: getDeviceType,
  getPlatformName: getPlatformName,
  isNaN: isNaN,
  LocalStorage: LocalStorage,
  Location: Location,
  QueryString: QueryString,
  toQueryString: toQueryString,
  seekStringToSeconds: seekStringToSeconds,
  rstr2hex: rstr2hex,
  rstr2b64: rstr2b64,
  zeroPad: zeroPad,
  User: User,
  Uid: Uid,
  registerGlobal: registerGlobal,
  GlobalsManager: GlobalsManager,
  getUnixTimestamp: getUnixTimestamp,
  truncateTimeSeconds: truncateTimeSeconds,
  isTimestampOnHashNeeded: isTimestampOnHashNeeded,
  DOM: DOM,
  API_VERSION: API_VERSION,
  convertToString: convertToString,
  autoplayManager: autoplayManager,
  session: session,
  checkRecoverableError: checkRecoverableError,
  getTimeFromPosition: getTimeFromPosition,
  getCurrentTime: getCurrentTime$1,
  getLiveDifferenceFromTime: getLiveDifferenceFromTime,
  getPositionFromTime: getPositionFromTime
});

var Styler = {
  getStyleFrom: function getStyleFrom(style) {
    var receivedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: ''
    };
    var options = receivedOptions || {};
    var text = template(style.toString())(options);
    if (options.playerId) text = text.replace(/\#wp3-player-0/g, "#wp3-player-".concat(options.playerId)); // eslint-disable-line no-useless-escape

    return $$1('<style class="clappr-style"></style>').html(text);
  }
};

var Events = function Events() {
  _classCallCheck(this, Events);
};
Events.WM_PLAY_REQUESTED = 'wm:play:requested';
Events.WM_USER_PLAY_REQUESTED = 'wm:user:play:requested';
Events.WM_PLAY_REQUESTED_READY = 'wm:play:requested:ready';
Events.CHROMECAST_SCRIPT_ERROR = 'chromecast:script:error';
Events.CHROMECAST_SCRIPT_LOADED = 'chromecast:script:loaded';
Events.CHROMECAST_API_ERROR = 'chromecast:api:error';
Events.CHROMECAST_API_READY = 'chromecast:api:ready';
Events.CHROMECAST_INITIALIZE_ERROR = 'chromecast:initialize:error';
Events.CHROMECAST_INITIALIZE_SUCCESS = 'chromecast:initialize:success';
Events.CHROMECAST_AVAILABLE = 'chromecast:available';
Events.CHROMECAST_UNAVAILABLE = 'chromecast:unavailable';
Events.CHROMECAST_LAUNCH_REQUEST = 'chromecast:launch:request';
Events.CHROMECAST_LAUNCH_ERROR = 'chromecast:launch:error';
Events.CHROMECAST_LAUNCH_SUCCESS = 'chromecast:launch:success';
Events.CHROMECAST_MEDIA_LOAD_ERROR = 'chromecast:mediaload:error';
Events.CHROMECAST_MEDIA_LOAD_SUCCESS = 'chromecast:mediaload:success';
Events.CHROMECAST_MEDIA_WATCHING = 'chromecast:media:watching';
Events.CHROMECAST_MEDIA_STOP_WATCHING = 'chromecast:mediastop:watching';
Events.ADS_REQUEST_READY = 'ads:request:ready';
Events.DFP_MANAGER_LOADED = 'dfp:manager:loaded';
Events.DFP_ENABLE = 'dfp:enable';
Events.DFP_DISABLE = 'dfp:disable';
Events.DFP_AD_LOADED = 'dfp:ad:loaded';
Events.DFP_AD_CLOSED = 'dfp:ad:closed';
Events.DFP_AD_STARTED = 'dfp:ad:started';
Events.DFP_AD_RESUME = 'dfp:playback:resume';
Events.DFP_AD_PAUSE = 'dfp:playback:pause';
Events.DFP_AD_CLICKED = 'dfp:ad:clicked';
Events.DFP_AD_COMPLETED = 'dfp:ad:completed';
Events.DFP_AD_SKIPPED = 'dfp:ad:skipped';
Events.DFP_AD_NOTSERVED = 'dfp:ad:notserved';
Events.DFP_AD_ERROR = 'dfp:ad:error';
Events.DFP_AD_METADATA = 'dfp:metadata';
Events.DFP_ALL_ADS_COMPLETED = 'dfp:allads:completed';
Events.DFP_CONTENT_PAUSE = 'dfp:content:pause';
Events.DFP_CONTENT_RESUME = 'dfp:content:resume';
Events.DFP_CONTENT_STARTED = 'dfp:content:started';
Events.DFP_CONTENT_ENDED = 'dfp:content:ended';
Events.DFP_FINISHED = 'dfp:finished';
Events.DFP_AD_BREAK_READY = 'dfp:adbreak:ready';
Events.DFP_INVALID_AD = 'dfp:invalid:ad';
Events.YOUBORA_TIMEMARK = 'youbora:timemark';
Events.DID_LOAD_CUEPOINTS = 'wm:didloadcuepoints';
Events.DID_REACH_CUEPOINT = 'wm:didreachcuepoint';
Events.DID_LOAD_EPG = 'wm:didloadepg';
Events.DID_CHANGE_CURRENT_PROGRAM = 'wm:didchangecurrentprogram';
Events.WM_STREAMING_DATA_LOADED = 'wm:streamingdata:loaded';
Events.WM_VIDEO_METADATA_REQUEST_COMPLETE = 'wm:videometadata:request:complete';
Events.WM_VIDEO_METADATA_LOADED = 'wm:videometadata:loaded';
Events.WM_VIDEO_METADATA_ERROR = 'wm:videometadata:error';
Events.WM_RESOURCE_LOADED = 'wm:resource:loaded';
Events.WM_RESOURCE_SELECTED = 'wm:resource:selected';
Events.WM_RESOURCE_REQUEST_STATS = 'wm:resource:request:stats';
Events.WM_AUTOPLAY_BLOCKED = 'wm:autoplay:blocked';
Events.WM_REQUEST_HASH = 'wm:request:hash';
Events.WM_HASH_RECEIVED = 'wm:hash:received';
Events.WM_RESOURCE_READY = 'wm:resource:ready';
Events.WM_RESOURCE_ERROR = 'wm:resource:error';
Events.WM_SETTINGS_SHOW = 'wm:settings:show';
Events.WM_VOLUME_SHOW = 'wm:volume:show';
Events.WM_VOLUME_HIDE = 'wm:volume:hide';
Events.WM_MUTED = 'wm:muted';
Events.WM_UNMUTED = 'wm:unmuted';
Events.WM_SHARE_SHOW = 'wm:share:show';
Events.WM_SHARE_HIDE = 'wm:share:hide';
Events.WM_SPINNER_START = 'wm:spinner:start';
Events.WM_SPINNER_STOP = 'wm:spinner:stop';
Events.WM_SETTINGS_HIDE = 'wm:settings:hide';
Events.WM_SETTINGS_OPTIONS_CHANGED = 'wm:settings:options:changed';
Events.WM_SETTINGS_LEVEL_SELECTED = 'wm:settings:level:selected';
Events.WM_LEVELSELECTOR_READY = 'wm:levelselector:ready';
Events.WM_AUDIOSELECTOR_READY = 'wm:audioselector:ready';
Events.STREAMSENSE_READY = 'streamsense:ready';
Events.WM_SUBTITLE_CHANGED = 'wm:subtitle:changed';
Events.WM_SUBTITLE_CONTENT_CHANGED = 'wm:subtitle:content:changed';
Events.WM_SUBTITLE_AVAILABLE = 'wm:subtitle:available';
Events.WM_AUDIO_CHANGED = 'wm:audio:changed';
Events.WM_AUDIO_AVAILABLE = 'wm:audio:available';
Events.WM_WROOM_WAITING = 'wm:waiting:wroom';
Events.WM_PLAYBACK_CAN_PLAY = 'wm:playback:canplay';
Events.WM_PLAYBACK_WILL_PLAY = 'wm:playback:willplay';
Events.WM_PLAYBACK_BUILT = 'wm:playback:built';
Events.WM_PIP_ADDED = 'wm:pip:added';
Events.WM_PIP_DISCARDED = 'wm:pip:discarded';
Events.WM_MASTER_ADDED = 'wm:master:added';
Events.WM_MASTER_CHANGED = 'wm:master:changed';
Events.WM_PIPTOMASTER = 'wm:piptomaster';
Events.WM_MASTERTOPIP = 'wm:mastertopip';
Events.WM_STATS_REPORTED = 'wm:stats:reported';
Events.WM_LOCATION_AVAILABLE = 'wm:location:available';
Events.WM_GA_UNTRACKED_EVENT = 'wm:ga:untracked:event';
Events.WILL_CHANGE_SOURCE = 'willChangeSource';
Events.WILL_SELECT_FALLBACK_SOURCE = 'will:select:fallback:source';
Events.FALLBACK_SOURCE_SELECTED = 'fallback:source:selected';
Events.WILL_RENEW_RESOURCE = 'willRenewResource';
Events.WM_BITRATE_CAP = 'wm:bitrate:cap';
Events.PLAYER_PIP_ADDED = 'player:pip:added';
Events.PLAYER_PIP_DISCARDED = 'player:pip:discarded';
Events.PLAYER_MASTER_ADDED = 'player:master:added';
Events.PLAYER_MASTER_CHANGED = 'player:master:changed';
Events.PLAYER_PIPTOMASTER = 'player:piptomaster';
Events.PLAYER_CAN_PLAY = 'player:canplay';
Events.WILL_SHOW_MODAL_ELEMENT = 'will:show:mediacontrol:element:modal';
Events.DID_HIDE_MODAL_ELEMENT = 'did:hide:mediacontrol:element:modal';
Events.MEDIACONTROL_MODAL_SHOW = 'mediacontrol:showmodal';
Events.MEDIACONTROL_MODAL_HIDE = 'mediacontrol:hidemodal';
Events.MEDIACONTROL_KEEPVISIBLE = 'mediacontrol:keepvisible';
Events.MEDIACONTROL_ITEMCLICKED = 'mediacontrol:itemclicked';
Events.MEDIACONTROL_DOUBLE_TAP = 'mediacontrol:doubletap';
Events.WILL_QUICK_SEEK = 'will:quickseek';
Events.WILL_SHOW_QUICK_SEEK_HINT = 'will:show:quick:seek:hint';
Events.WILL_HIDE_QUICK_SEEK_HINT = 'will:hide:quick:seek:hint';
Events.PLAYER_MEDIACONTROL_SHOW = 'player:mediacontrol:show';
Events.PLAYER_MEDIACONTROL_HIDE = 'player:mediacontrol:hide';
Events.SKIP_BUTTON_SHOW = 'skip:button:show';
Events.SKIP_BUTTON_HIDE = 'skip:button:hide';
Events.SKIP_BUTTON_CLICKED = 'skip:button:clicked';
Events.BACK_BUTTON_CLICKED = 'back:button:clicked';
Events.TAP_TO_UNMUTE_CLICKED = 'taptounmute:clicked';
Events.TAP_TO_UNMUTE_SHOW = 'taptounmute:show';
Events.WILL_AUTO_SKIP_RECAP = 'will:auto:skip:recap';
Events.START_DRAGGING_SEEKBAR = 'start:dragging:seekbar';
Events.STOP_DRAGGING_SEEKBAR = 'stop:dragging:seekbar';
Events.SIMULCAST_PING = 'simulcastPing';
Events.SHOW_HEADER_REQUESTED = 'show:header:requested';
Events.WILL_SHOW_HEADER = 'will:show:header';
Events.DID_SHOW_HEADER = 'did:show:header';
Events.CLOSE_HEADER_REQUESTED = 'close:header:requested';
Events.WILL_CLOSE_HEADER = 'will:close:header';
Events.DID_CLOSE_HEADER = 'did:close:header';
Events.WILL_SHOW_DRAWER = 'will:show:drawer';
Events.DID_SHOW_DRAWER = 'did:show:drawer';
Events.DID_SHOW_DRAWER_HINT = 'did:show:drawer:hint';
Events.WILL_HIDE_DRAWER = 'will:hide:drawer';
Events.DID_HIDE_DRAWER = 'did:hide:drawer';
Events.DID_HIDE_DRAWER_HINT = 'did:hide:drawer:hint';
Events.HIDE_DRAWER_REQUESTED = 'hide:drawer:requested';
Events.SHOW_DRAWER_REQUESTED = 'show:drawer:requested';
Events.DRAWER_HAS_PLACEHOLDER = 'drawer:has:placeholder';
Events.SHOW_HEADER_REQUESTED = 'show:header:requested';
Events.SYNC_DRAWER_STATE_REQUEST = 'sync:drawer:state:request';
Events.SYNC_DRAWER_STATE_RESPONSE = 'sync:drawer:state:response';
Events.DID_SHOW_OVERLAY = 'did:show:overlay';
Events.DID_HIDE_OVERLAY = 'did:hide:overlay';
Events.WILL_RESTART_PLAYBACK = 'will:restart:playback';
Events.DID_RESTART_PLAYBACK = 'did:restart:playback';
Events.WATCH_SESSION_START = 'watchsession:start';
Events.WATCH_SESSION_END = 'watchsession:end';
Events.LANGUAGE_MENU_WILL_OPEN = 'language:menu:will:open';
Events.LANGUAGE_MENU_WILL_CLOSE = 'language:menu:will:close';

var DEFAULT_PROFILE = 'max';
var DEFAULT_CDN = 'globo';

var DEFAULT_OPTIONS = {
  hlsMinimumDvrSize: 120,
  playback: {
    controls: true,
    preload: 'none',
    playInline: true,
    recycleVideo: Browser.isMobile
  },
  allowLocation: false,
  disableVideoTagContextMenu: true,
  maxQualityLevel: DEFAULT_PROFILE,
  skipWaitingRoom: false
};

var PlayerPublicAPI = /*#__PURE__*/function (_Clappr$Player) {
  _inherits(PlayerPublicAPI, _Clappr$Player);

  var _super = _createSuper(PlayerPublicAPI);

  function PlayerPublicAPI() {
    _classCallCheck(this, PlayerPublicAPI);

    return _super.apply(this, arguments);
  }

  _createClass(PlayerPublicAPI, [{
    key: "_addContainerEventListeners",
    value: function _addContainerEventListeners() {
      _get(_getPrototypeOf(PlayerPublicAPI.prototype), "_addContainerEventListeners", this).call(this);

      var playback = this.core.getCurrentPlayback();
      this.listenToOnce(playback, Events.WM_RESOURCE_READY, this.onResourceReady);
      this.listenToOnce(playback, Events.WM_PLAYBACK_CAN_PLAY, this.onCanPlay);
    }
  }, {
    key: "onCanPlay",
    value: function onCanPlay() {
      this.trigger(Events.PLAYER_CAN_PLAY);
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady(video) {
      if (this.options.onAuthorized) {
        var hashData = video && video.selectedResource && video.selectedResource.hashData;
        hashData && this.options.onAuthorized(hashData);
      }
    }
  }, {
    key: "version",
    value: function version() {
      return PlayerPublicAPI.version;
    }
  }, {
    key: "allVersions",
    value: function allVersions() {
      return PlayerPublicAPI.allVersions;
    }
  }, {
    key: "resize",
    value: function resize(size) {
      $$1(this.element).css({
        width: size.width,
        height: size.height
      });
      this.core && _get(_getPrototypeOf(PlayerPublicAPI.prototype), "resize", this).call(this, size);
    }
  }, {
    key: "eventsMapping",
    get: function get() {
      return Object.assign(_get(_getPrototypeOf(PlayerPublicAPI.prototype), "eventsMapping", this), {
        onCanPlay: Events.PLAYER_CAN_PLAY
      });
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return DEFAULT_OPTIONS;
    }
  }], [{
    key: "version",
    get: function get() {
      return "1.18.1-resource-renew";
    }
  }, {
    key: "allVersions",
    get: function get() {
      return {
        Player: PlayerPublicAPI.version,
        Clappr: Clappr.version
      };
    }
  }]);

  return PlayerPublicAPI;
}(Clappr.Player);

if (!window.console) {
  var replacementConsole = {
    log: function log() {}
  };
  window.console = replacementConsole;
}
Clappr.Log.setLevel(Clappr.Log.LEVEL_WARN);
var PlayerSettings = window.WM && window.WM.Settings || {};
var DOMAINS = PlayerSettings && PlayerSettings.Domains || [];
var isIframe$1 = Utils.DOM.isIframe;

var Player = /*#__PURE__*/function (_PlayerCoreAPI) {
  _inherits(Player, _PlayerCoreAPI);

  var _super = _createSuper(Player);

  _createClass(Player, [{
    key: "container",
    get: function get() {
      return this.core.getCurrentContainer();
    }
  }, {
    key: "playback",
    get: function get() {
      return this.core.getCurrentPlayback();
    }
  }]);

  function Player() {
    var externalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Player);

    var options = _objectSpread2(_objectSpread2({}, DEFAULT_OPTIONS), externalOptions);

    options.env = Environment.get(options.env, options.httpOnly, options.customEnv); // For cookie related purposes, localhost should use the same logic as globo.com domains.
    // This is necessary to prevent running test suites from always running using flat URLs. It's also useful for local tests.

    var isTestEnvironment = process.env.NODE_ENV === 'test';
    var isLocalTestEnvironment = Environment.isLocalhost && isTestEnvironment;
    var isThirdPartyDomain = !Environment.isGloboDomain;
    var isCookielessEnvironment = Browser.isSafari || Browser.isiOS || Browser.isSmartTvEnvironment;
    var isMobileIframe = Browser.isMobile && (isIframe$1() || options.isIFrame);
    var isInsecureEnv = window.location && window.location.protocol !== 'https:';
    Browser.preventUsingCookies = (isThirdPartyDomain || isCookielessEnvironment || isMobileIframe || isInsecureEnv) && !isLocalTestEnvironment;
    return _super.call(this, options);
  }

  _createClass(Player, [{
    key: "attachTo",
    value: function attachTo(element) {
      $$1(element).html('');
      this.element = element;
      this.options.parentElement = element;
      this.options.customStyle && this._renderCustomStyles(element, this.options.customStyle);
      this.core && this.core.destroy();

      _get(_getPrototypeOf(Player.prototype), "attachTo", this).call(this, element);

      this.core.$el.attr('id', "wp3-player-".concat(this.core.options.playerId));
      this.core.$el.addClass('clappr-player');
    }
  }, {
    key: "_renderCustomStyles",
    value: function _renderCustomStyles(parent, customStyles) {
      var _this = this;

      Object.values(customStyles).forEach(function (style) {
        var styleElem = Styler.getStyleFrom(style, {
          playerId: _this.options.playerId
        });
        $$1(parent).append(styleElem);
      });
    }
  }]);

  return Player;
}(PlayerPublicAPI);
Browser.supportsFakeLocation = /puffin/i.test(navigator.userAgent);

Player.isAllowedDomain = function (domain) {
  return !PlayerSettings.Domains || DOMAINS.find(function (pattern) {
    return pattern.test(domain);
  });
};

window.Clappr = window.Clappr || Clappr;

var Video = /*#__PURE__*/function () {
  _createClass(Video, [{
    key: "isLive",
    get: function get() {
      return this.type === 'Live';
    }
  }, {
    key: "posterTemplate",
    get: function get() {
      var _this$options$env;

      return (_this$options$env = this.options.env) === null || _this$options$env === void 0 ? void 0 : _this$options$env.posterTemplate;
    }
  }]);

  function Video(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Video);

    this.options = options;
    this.id = json.id;
    this.title = json.title;
    this.kind = json.kind;
    this.program = json.program;
    this.channel = json.channel;
    this.category = json.category;
    this.createdAt = json.created_at;
    this.exhibitedAt = json.exhibited_at;
    this.programId = json.program_id;
    this.channelId = json.channel_id;
    this.duration = json.duration;
    this.serviceId = json.service_id;
    this.providerId = json.provider_id;
    this.providerUrl = json.provider_url;
    this.type = json.type;
    this.affiliate = json.affiliate;
    this.geofencing = !!json.geofencing;
    this.isSubscriberOnly = !!json.subscriber_only;
    this.encrypted = !!json.encrypted;
    this.isArchived = json.archived;
    this.urlForConsumption = json.url_for_consumption;
    this.adult = json.adult;
    this.contentRating = json.content_rating;
    this.contentRatingCriteria = json.content_rating_criteria;
    this.isSelfRated = json.self_rated;
    this.adUnit = json.ad_unit;
    this.adCustomData = json.ad_custom_data;
    this.adAccountId = json.ad_account_id;
    this.adCmsId = json.ad_cms_id;
    this.cuepoints = json.cuepoints;
    var getPlayerType = options.getPlayerType;
    this.playerType = typeof getPlayerType === 'function' && getPlayerType(this, options.isLimited);
    this.playerType || (this.playerType = Video.getPlayerType(this, options.isLimited));
    this.rawData = json;
    this.rawData.videos = [json]; // Backwards compatibility (Player API)

    this.selectedLevel = options.selectedLevel;
    this.preferredLevel = options.preferredLevel;
    this.preferredCDN = options.preferredCDN;
    this.posterImageUrls = this.createPosterImageUrl();
    this.drm = Video.getDRMProtocol();
  }

  _createClass(Video, [{
    key: "createPosterImageUrl",
    value: function createPosterImageUrl() {
      var _this = this;

      var template = this.posterTemplate;

      if (template) {
        var availableHeights = [240, 360, 720];
        var domainNumber = Number(this.id) % 4 + 1;
        var posterImageUrls = {};
        availableHeights.forEach(function (item) {
          posterImageUrls[item] = template({
            domainNumber: domainNumber,
            size: "x".concat(item),
            videoId: _this.id
          });
        });
        return posterImageUrls;
      }
    }
  }], [{
    key: "getDRMProtocol",
    value: function getDRMProtocol() {
      if (Browser.isSmartTvEnvironment) return 'playready';else if (Browser.isSafari || Browser.isiOS) return 'fairplay';else if (Browser.isChrome || Browser.isFirefox || Browser.isChromecast) return 'widevine';
      return 'playready';
    }
  }, {
    key: "getPlayerType",
    value: function getPlayerType() {
      var limited = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // eslint-disable-line no-unused-vars
      if (!Browser.isMobile) {
        if (Browser.isChromecast) return 'chromecast';
        return Browser.isSafari ? 'safari' : Browser.preventUsingCookies ? 'desktop_flat' : 'desktop';
      } else if (Browser.isAndroid) {
        return limited ? 'android_limited' : Browser.preventUsingCookies ? 'android_flat' : 'android';
      } else if (Browser.isiOS) {
        return 'safari_mobile';
      } else if (Browser.isWindowsPhone) {
        return 'windows_phone';
      }

      return 'html5';
    }
  }]);

  return Video;
}();

var VIDEO_ID_REGEX = /^\d+$/;
var MimeTypes = Object.freeze({
  VIDEO_ID: 'application/vnd.globo.videoid'
});
var isVideoId = function isVideoId(source, mimeType) {
  return VIDEO_ID_REGEX.test(source) || mimeType === MimeTypes.VIDEO_ID;
};

Events$1.register('PLAYBACK_METADATA_TRACK_CUE_CHANGE');

var HTML5Playback = /*#__PURE__*/function (_HTML5Video) {
  _inherits(HTML5Playback, _HTML5Video);

  var _super = _createSuper(HTML5Playback);

  _createClass(HTML5Playback, [{
    key: "name",
    get: function get() {
      return 'html5';
    }
  }, {
    key: "isLive",
    get: function get() {
      return this.getPlaybackType() === Playback.LIVE;
    }
  }, {
    key: "dvrEnabled",
    get: function get() {
      return this.getDuration() >= this._minDvrSize && this.isLive;
    }
  }, {
    key: "minimumDVRSizeConfig",
    get: function get() {
      return this.options.playback && this.options.playback.minimumDvrSize;
    }
  }, {
    key: "isValidMinimumDVRSizeConfig",
    get: function get() {
      return typeof this.minimumDVRSizeConfig !== 'undefined' && typeof this.minimumDVRSizeConfig === 'number';
    }
  }]);

  function HTML5Playback() {
    var _this;

    _classCallCheck(this, HTML5Playback);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this._minDvrSize = _this.isValidMinimumDVRSizeConfig ? _this.minimumDVRSizeConfig : 60;
    _this.onAddTrack = _this.onAddTrack.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HTML5Playback, [{
    key: "pause",
    value: function pause() {
      this.el.pause();
      this.dvrEnabled && this._updateDvr(true);
    }
  }, {
    key: "_updateDvr",
    value: function _updateDvr(status) {
      this.trigger(Events$1.PLAYBACK_DVR, status);
      this.trigger(Events$1.PLAYBACK_STATS_ADD, {
        dvr: status
      });
    }
  }, {
    key: "seek",
    value: function seek(time) {
      var positionToSeek = time;

      if (time < 0) {
        Log$1.warn('Attempt to seek to a negative time. Resetting to live point. Use seekToLivePoint() to seek to the live point.');
        positionToSeek = this.getDuration();
      } // assume live if time within 3 seconds of end of stream


      this.dvrEnabled && this._updateDvr(time < this.getDuration() - 3);
      positionToSeek += this.el.seekable.start(0);
      this.el.currentTime = positionToSeek;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      var _this2 = this;

      if (this.isLive) try {
        return this.el.seekable.end(0) - this.el.seekable.start(0);
      } catch (error) {
        setTimeout(function () {
          return _this2._updateSettings();
        }, 1000);
      }
      return this.el.duration;
    }
  }, {
    key: "_onTimeUpdate",
    value: function _onTimeUpdate() {
      var duration = this.isLive ? this.getDuration() : this.el.duration;
      this.trigger(Events$1.PLAYBACK_TIMEUPDATE, {
        current: this.el.currentTime,
        total: duration
      }, this.name);
    }
  }, {
    key: "onAddTrack",
    value: function onAddTrack(event) {
      var _this3 = this;

      var track = event.track;

      if (track.kind === 'metadata') {
        track.mode = 'hidden';
        track.addEventListener('cuechange', function () {
          var _iterator = _createForOfIteratorHelper(track.activeCues),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var cue = _step.value;

              var metadata = _defineProperty({}, cue.value.key, cue.value.data);

              _this3.trigger(Events$1.Custom.PLAYBACK_METADATA_TRACK_CUE_CHANGE, metadata);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.el.textTracks.removeEventListener('addtrack', this.onAddTrack);

      _get(_getPrototypeOf(HTML5Playback.prototype), "destroy", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(HTML5Playback.prototype), "render", this).call(this);

      this.el.textTracks.addEventListener('addtrack', this.onAddTrack);
      return this;
    }
  }]);

  return HTML5Playback;
}(HTML5Video);

var DRM_DEVICE_ID = 'ZDY4NDM5MDgtMzQ4Mi0zZGU5LThlZDQtYjRiNWM5ZjBmOWU5';
var DRM_DEVICE_ID_EXP = /{{deviceId}}/g;

var getDRMServerWithDeviceId = function getDRMServerWithDeviceId(receivedResource, httpOnly) {
  var resource = httpOnly ? receivedResource.replace('https://', 'http://') : receivedResource;
  return resource.replace(DRM_DEVICE_ID_EXP, DRM_DEVICE_ID);
};

var getDRMConfig = function getDRMConfig(video) {
  var httpOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var type = video.drm || {};
  var contentProtection = video.selectedResource.contentProtection;
  var licenseServer = {};
  licenseServer[type] = getDRMServerWithDeviceId(contentProtection.server, httpOnly);
  return {
    shakaConfiguration: {
      drm: {
        servers: {
          'com.microsoft.playready': licenseServer.playready || '',
          'com.widevine.alpha': licenseServer.widevine || ''
        }
      }
    },
    fairplay: {
      server: licenseServer.fairplay || '',
      certificate: contentProtection && contentProtection.cert
    },
    licenseServer: licenseServer
  };
};

var findPlaybackPlugin = function findPlaybackPlugin(source, options, isEncrypted) {
  var playbacks = options.loader.playbackPlugins;
  return playbacks.find(function (playback) {
    return playback.canPlay(source.toString(), '', isEncrypted);
  });
};

var createPlayback = function createPlayback(resourceUrl) {
  var selectedResource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fallbackUrl = arguments.length > 2 ? arguments[2] : undefined;
  // eslint-disable-line default-param-last
  var idPlayback = this;
  var basicResourceUrl = !Browser.isChromecast && selectedResource && selectedResource.url;
  var src = resourceUrl || basicResourceUrl || fallbackUrl;
  var isEncrypted = this.video && this.video.encrypted;
  var forceHTML5 = Browser.isiOS && !isEncrypted && HTML5Playback.canPlay(src.toString(), '', isEncrypted);
  var PlaybackImpl = forceHTML5 ? HTML5Playback : findPlaybackPlugin(src, idPlayback.options, isEncrypted);
  var contentProtection = selectedResource && selectedResource.contentProtection;
  var drmConfig = isEncrypted && contentProtection ? getDRMConfig(this.video, idPlayback.options.httpOnly) : {};
  var shakaServerDRMConfig = drmConfig.shakaConfiguration && drmConfig.shakaConfiguration.drm || {};
  var shakaTuningDRMConfig = idPlayback.options.shakaConfiguration && idPlayback.options.shakaConfiguration.drm || {};
  var shakaDrmConfig = {
    drm: _objectSpread2(_objectSpread2({}, shakaServerDRMConfig), shakaTuningDRMConfig)
  };

  var options = _objectSpread2(_objectSpread2(_objectSpread2({}, idPlayback.options), drmConfig), {}, {
    shakaConfiguration: _objectSpread2(_objectSpread2(_objectSpread2({}, idPlayback.options.shakaConfiguration || {}), drmConfig.shakaConfiguration || {}), shakaDrmConfig),
    autoPlay: false,
    isLivePlayback: idPlayback.getPlaybackType() === 'live',
    src: src
  });

  return new PlaybackImpl(options, idPlayback.i18n, idPlayback.playerError);
};

var getPlaybackError = function getPlaybackError(error, options, video) {
  var Errors$1 = options.customErrors ? options.customErrors : Errors;
  var playbackError = Errors$1.DEFAULT_ERROR;

  if (error.code === Errors$1.NOT_FOUND.code || error.message === 'Not found') {
    playbackError = Errors$1.NOT_FOUND;
  } else if (error.code === Errors$1.SUBSCRIBERS_ONLY.code) {
    if (typeof options.onUnauthorized === 'function' && video) options.onUnauthorized(Object.assign(error, {
      fromPlayer3: true
    }), video.rawData);
    playbackError = Errors$1.SUBSCRIBERS_ONLY;
  } else if (error.code === Errors$1.AUTH_REQUIRED.code) {
    if (typeof options.onUnauthorized === 'function' && video) options.onUnauthorized(Object.assign(error, {
      fromPlayer3: true
    }), video.rawData);
    playbackError = Errors$1.AUTH_REQUIRED;
  } else if (error.code === Errors$1.GEO_BLOCKED.code) {
    playbackError = Errors$1.GEO_BLOCKED;
  } else if (error.code === Errors$1.DEVICE_NOT_AUTHORIZED.code) {
    playbackError = Errors$1.DEVICE_NOT_AUTHORIZED;
  } else if (error.code === Errors$1.SIMULTANEOUS_ACCESS.code) {
    playbackError = Errors$1.SIMULTANEOUS_ACCESS;
  } else if (error.code === Errors$1.DEVICE_NOT_SUPPORTED.code) {
    playbackError = Errors$1.DEVICE_NOT_SUPPORTED;
  } else if (error.code === Errors$1.GEOFENCING.code) {
    playbackError = Errors$1.GEOFENCING;
  } else if (error.http_status_code === 400 && error.code === 'SRF') {
    playbackError = Errors$1.GEOFENCING;
  } else if (error.code === Errors$1.TIMESTAMP_ERROR.code) {
    playbackError = _objectSpread2(_objectSpread2({}, Errors$1.TIMESTAMP_ERROR), {}, {
      description: "".concat(Errors$1.TIMESTAMP_ERROR.description, ", ts: ").concat(Math.trunc(getCurrentTime() / 1000))
    });
  } else if (error.code === Errors$1.LOCATION_UNAVAILABLE.code) {
    playbackError = Errors$1.LOCATION_UNAVAILABLE;
  } else if (error.code === Errors$1.RESTRICTED_CONTENT.code) {
    playbackError = Errors$1.RESTRICTED_CONTENT;
  } else if (error.code === Errors$1.NOT_ALLOWED_DOMAIN.code) {
    playbackError = Errors$1.NOT_ALLOWED_DOMAIN;
  } else if (error.code === Errors$1.UNSUPPORTED_BROWSER.code) {
    playbackError = Errors$1.UNSUPPORTED_BROWSER;
  } else if (error.code === Errors$1.PLAYER_NOT_RECOGNIZED.code) {
    playbackError = Errors$1.PLAYER_NOT_RECOGNIZED;
  }

  return playbackError;
};

var p2pLoader = /*#__PURE__*/function () {
  function p2pLoader(config) {
    _classCallCheck(this, p2pLoader);

    this.pLoader = new window.peer5.HlsJsPlaylistLoader(config);
  }

  _createClass(p2pLoader, [{
    key: "load",
    value: function load(context, config, callbacks) {
      this.pLoader.load(context, config, callbacks);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.pLoader.destroy();
    }
  }, {
    key: "abort",
    value: function abort() {
      this.pLoader.abort();
    }
  }]);

  return p2pLoader;
}();

var getPloader = function getPloader(playback) {
  var p2pEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!HLSJS) return undefined;
  var baseLoader = p2pEnabled ? p2pLoader : HLSJS.DefaultConfig.loader;

  var pLoader = /*#__PURE__*/function (_baseLoader) {
    _inherits(pLoader, _baseLoader);

    var _super = _createSuper(pLoader);

    function pLoader() {
      _classCallCheck(this, pLoader);

      return _super.apply(this, arguments);
    }

    _createClass(pLoader, [{
      key: "load",
      value: function load(context, config, callbacks) {
        if (context.type === 'manifest') {
          var onSuccess = callbacks.onSuccess;

          callbacks.onSuccess = function (response, stats, context, xhr) {
            var manifestData = {
              pop: xhr.getResponseHeader('x-pop'),
              host: xhr.getResponseHeader('x-host')
            };
            playback.trigger(Events.WM_STREAMING_DATA_LOADED, manifestData);
            onSuccess(response, stats, context);
          };
        }

        _get(_getPrototypeOf(pLoader.prototype), "load", this).call(this, context, config, callbacks);
      }
    }]);

    return pLoader;
  }(baseLoader);

  return playback.video.isLive ? pLoader : undefined;
};

var getFloader = function getFloader(playback, p2pEnabled) {
  var fLoader = p2pEnabled ? window.peer5.HlsJsFragmentLoader : undefined;
  return playback.video.isLive ? fLoader : undefined;
};

var HLSJSOptions = {
  enableWorker: false,
  liveSyncDurationCount: 2,
  capLevelToPlayerSize: true,
  enableWebVTT: false,
  xhrSetup: function xhrSetup(xhr) {
    xhr.withCredentials = true;
  }
};

var getTunningConfig = function getTunningConfig(options) {
  /**
   * The following values were obtained after some experimentation.
   * The hls.js library uses an exponential backoff strategy with a 500ms base delay, where:
   * - 3 retries amount to about 8s of total wait;
   * - 7 retries amount to about 2min of total wait.
   * Since the `hlsRecoverAttempts` is 1, the time for streaming retries will be doubled due to the extra attempt.
   * This extra attempt tries another load, doing the same amount of retries.
   */
  var manifestRetries = 3;
  var streamingRetries = 7;
  options.hlsRecoverAttempts = 1;
  return {
    manifestLoadingMaxRetry: manifestRetries,
    fragLoadingMaxRetry: streamingRetries,
    levelLoadingMaxRetry: streamingRetries
  };
};

var setHLSJSConfig = function setHLSJSConfig(receivedOptions, playback) {
  var options = _objectSpread2({
    p2pEnabled: false
  }, receivedOptions);

  var HLSJSTunningOptions = getTunningConfig(receivedOptions);
  receivedOptions.playback.hlsjsConfig = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, HLSJSOptions), HLSJSTunningOptions), receivedOptions.HLSJSConfiguration || {}), {}, {
    fLoader: getFloader(playback, options.p2pEnabled),
    pLoader: getPloader(playback, options.p2pEnabled)
  });
};

var PREFERRED_AUDIO_LANGUAGE = 'por';

var shakaOnBeforeLoad = function shakaOnBeforeLoad(shakaPlayer) {
  shakaPlayer.getNetworkingEngine().registerRequestFilter(function (type, request) {
    if (type !== shaka.net.NetworkingEngine.RequestType.LICENSE) request.allowCrossSiteCredentials = true;
  });
};

var setShakaTunningOptions = function setShakaTunningOptions(options) {
  /**
   * The following values were obtained after some experimentation.
   * The shaka library uses an exponential backoff strategy with a 1s base delay (configurable), where:
   * - 4 attempts amount to about 8s of total wait;
   * - 8 attempts amount to about 2min of total wait.
   * The times mentioned above might vary due to the jitter/fuzz factor employed in each request.
   */
  var manifestAttempts = 4;
  var streamingAttempts = 8;
  options.shakaConfiguration = options.shakaConfiguration || {};

  var retryParameters = function retryParameters(name) {
    return {
      maxAttempts: name === 'manifest' ? manifestAttempts : streamingAttempts
    };
  };

  var makeConfig = function makeConfig(name) {
    return _objectSpread2(_objectSpread2({}, options.shakaConfiguration[name] || {}), {}, {
      retryParameters: retryParameters(name)
    });
  };

  var requestTypes = ['drm', 'manifest', 'streaming'];
  requestTypes.forEach(function (name) {
    return options.shakaConfiguration[name] = makeConfig(name);
  });
};

var setShakaBufferingOptions = function setShakaBufferingOptions(options) {
  var bufferingParameters = {
    bufferingGoal: 120,
    rebufferingGoal: 2,
    bufferBehind: 30
  };
  options.shakaConfiguration = options.shakaConfiguration || {};
  options.shakaConfiguration.streaming = _objectSpread2(_objectSpread2({}, options.shakaConfiguration.streaming || {}), bufferingParameters);
};

var setShakaConfigFromSettings = function setShakaConfigFromSettings(options) {
  var forceDefaultConfigFromSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var alternative = getExperimentAlternative(options, 'player-isolated-experiment-01');
  var PlayerSettings = window.WM && window.WM.Settings || {};
  var shakaConfigs = PlayerSettings.ShakaConfig || {};
  var defaultConfig = shakaConfigs['shaka-config-set-control'] || {};
  var configSet = forceDefaultConfigFromSettings ? defaultConfig : shakaConfigs[alternative] || defaultConfig;
  options.shakaConfiguration = _objectSpread2(_objectSpread2({}, options.shakaConfiguration), {}, {
    streaming: _objectSpread2(_objectSpread2({}, options.shakaConfiguration.streaming || {}), configSet.streaming),
    abr: _objectSpread2(_objectSpread2({}, options.shakaConfiguration.abr || {}), configSet.abr)
  });
};

var setShakaManifestConfig = function setShakaManifestConfig(options) {
  options.shakaConfiguration = _objectSpread2(_objectSpread2({}, options.shakaConfiguration), {}, {
    manifest: _objectSpread2(_objectSpread2({}, options.shakaConfiguration.manifest || {}), {}, {
      dash: _objectSpread2(_objectSpread2({}, options.shakaConfiguration.manifest && options.shakaConfiguration.manifest.dash || {}), {}, {
        ignoreMinBufferTime: true
      })
    })
  });
};

var setShakaPreferredAudio = function setShakaPreferredAudio(options) {
  var _options$defaultAudio;

  options.shakaConfiguration = _objectSpread2(_objectSpread2({}, options.shakaConfiguration), {}, {
    preferredAudioLanguage: ((_options$defaultAudio = options.defaultAudio) === null || _options$defaultAudio === void 0 ? void 0 : _options$defaultAudio.language) || PREFERRED_AUDIO_LANGUAGE
  });
};

var setShakaConfig = function setShakaConfig(options) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$forceDefaultConf = _ref.forceDefaultConfigFromSettings,
      forceDefaultConfigFromSettings = _ref$forceDefaultConf === void 0 ? false : _ref$forceDefaultConf;

  options.shakaOnBeforeLoad = shakaOnBeforeLoad;
  options.shakaMinimumDvrSize = 180;
  options.shakaConfiguration = options.shakaConfiguration || {};
  setShakaTunningOptions(options);
  setShakaBufferingOptions(options);
  setShakaConfigFromSettings(options, forceDefaultConfigFromSettings);
  setShakaManifestConfig(options);
  setShakaPreferredAudio(options);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".clappr-player#wp3-player-0 .id-playback.cover-viewport video {\n  -o-object-fit: cover;\n     object-fit: cover; }\n";
styleInject(css_248z);

var Log = Clappr.Log.getInstance();
Events$1.register('PLAYBACK_AUTHORIZED');

var IdPlayback = /*#__PURE__*/function (_Playback) {
  _inherits(IdPlayback, _Playback);

  var _super = _createSuper(IdPlayback);

  _createClass(IdPlayback, [{
    key: "name",
    get: function get() {
      return 'id_playback';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "attributes",
    get: function get() {
      return {
        "class": 'id-playback',
        'data-id-playback': ''
      };
    }
  }, {
    key: "srcUrl",
    get: function get() {
      var html5VideoSrc = this.playback && this.playback.options && this.playback.options.src;
      var flashVideoSrc = this.playback && this.playback._src;
      return html5VideoSrc || flashVideoSrc || this.options.src;
    }
  }, {
    key: "blackResourceUrl",
    get: function get() {
      return Browser.isChromecast ? this.options.env.blackVideoUrl : !Browser.isiOS && !Browser.isSafari && this.video.encrypted ? this.options.env.blackDashUrl : this.options.env.blackVideoStreamingUrl;
    }
  }, {
    key: "src",
    get: function get() {
      return this.options.src;
    }
  }, {
    key: "selectedResource",
    get: function get() {
      return this.video && this.video.selectedResource;
    }
  }, {
    key: "isEncrypted",
    get: function get() {
      return this.video && this.video.encrypted;
    }
  }, {
    key: "isReady",
    get: function get() {
      return this._isReady;
    }
  }, {
    key: "defaultSettings",
    get: function get() {
      return {
        seekEnabled: true
      };
    }
  }, {
    key: "dvrEnabled",
    get: function get() {
      return this.playback ? !!this.playback.dvrEnabled : false;
    }
  }, {
    key: "levels",
    get: function get() {
      return this.playback.levels;
    }
  }, {
    key: "buffering",
    get: function get() {
      return this.playback && this.playback.buffering;
    }
  }, {
    key: "videoEl",
    get: function get() {
      return this.playback && this.playback.el;
    }
  }, {
    key: "innerPlaybackName",
    get: function get() {
      return this.playback && this.playback.name || '';
    }
  }, {
    key: "isLive",
    get: function get() {
      return this.getPlaybackType() === Playback.LIVE;
    }
  }, {
    key: "liveInitialPosition",
    get: function get() {
      return getPositionFromTime(this.playback, this.options.liveStartTime);
    }
  }, {
    key: "useSingleAudioUrls",
    get: function get() {
      return Browser.isSmartTvEnvironment;
    }
  }, {
    key: "audioTracks",
    get: function get() {
      if (this.useSingleAudioUrls) return this.selectedResource && this.selectedResource.audioTracksForSingleAudioUrls || [];
      return this.playback && this.playback.audioTracks || [];
    }
  }, {
    key: "currentAudioTrack",
    get: function get() {
      return this.currentAudio;
    }
  }, {
    key: "bandwidthEstimate",
    get: function get() {
      return this.playback && this.playback.bandwidthEstimate;
    }
  }]);

  function IdPlayback() {
    var _this;

    _classCallCheck(this, IdPlayback);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this._isReady = false;

    _this.bindEvents();

    _this.$el.css('height', '100%');

    _this.settings = _this.defaultSettings;
    _this.options.swfBasePath = _this.options.baseUrl;
    _this.options.startFromBitrate = 400000;
    _this.currentVolume = null;
    _this.currentTime = 0;
    _this.duration = 0;
    _this.isRenewingResource = false;
    _this.skipWaitingGlobals = false;
    _this.actionsMetadata = {};
    _this.globalsManager = new GlobalsManager();

    _this.setupSession();

    return _this;
  }

  _createClass(IdPlayback, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.on(Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
      this.on(Events.WM_VIDEO_METADATA_ERROR, this.onVideoMetadataError);
      this.on(Events.WM_RESOURCE_READY, this.onResourceReady);
      this.on(Events.WM_RESOURCE_ERROR, this.onResourceLoadError);
      this.on(Events.WM_PLAYBACK_WILL_PLAY, this.onBeforePlay);
      this.on(Events.DID_RESTART_PLAYBACK, this.onPlaybackRestarted);
      this.on(Events.FALLBACK_SOURCE_SELECTED, this.onFallbackSourceSelected);
    }
  }, {
    key: "onPlaybackRestarted",
    value: function onPlaybackRestarted() {
      this.isRestarting = false;
    }
  }, {
    key: "play",
    value: function play() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.trigger(Events.WM_PLAY_REQUESTED);
      this.actionsMetadata.playEvent = options;
      this.isRestarting && this.trigger(Events.DID_RESTART_PLAYBACK);

      if (this.canRequestPlay()) {
        this.loadingResource = true;
        this.trigger(Events.WM_PLAY_REQUESTED_READY, this.video);
      } else if (!this.checkingAutoplayPermission) {
        // eslint-disable-line no-negated-condition
        this.startAutoPlayCheck({
          autoPlay: true
        });
      } else if (this.isPaused) {
        this.playWhenReady();
      } else {
        Log.debug(this.name, 'Call to play was ignored');
      }
    }
  }, {
    key: "canRequestPlay",
    value: function canRequestPlay() {
      var ignorePlayRequest = this.waitToPlay() || this.playbackError || this.isPlaying();
      var readyToRequest = this.video && !this._resourceReady && !this.loadingResource;
      var isPlayAllowed = autoplayManager.isAvailable(this.options.mute) || this.mutedAutoplay || Browser.isSmartTvEnvironment;
      return !ignorePlayRequest && readyToRequest && isPlayAllowed;
    }
  }, {
    key: "playWhenReady",
    value: function playWhenReady() {
      var _this2 = this;

      if (this.isReady) {
        setTimeout(function () {
          return _this2.playback.play();
        });
      } else {
        this.listenToOnce(this, Events.WM_PLAYBACK_WILL_PLAY, this.playWhenReady);
        this.prepareInnerPlaybackToPlay();
      }
    }
  }, {
    key: "onBeforePlay",
    value: function onBeforePlay() {
      /*
          The disablePlayWhenReady flag is set to true when DFP (or any other plugin)
          needs to manually control the playback startup, by calling playWhenReady itself.
       */
      if (!this.isRestarting && this.disablePlayWhenReady) return;
      this.playWhenReady();
    }
  }, {
    key: "consent",
    value: function consent() {
      this.playback.consent();
      autoplayManager.consent();
      this.mutedAutoplay = false;
    }
  }, {
    key: "waitToPlay",
    value: function waitToPlay() {
      var _this3 = this;

      var waiting = true;
      var waitingGlobals = !this.globalsManager.ready();
      var waitingPlayback = !this.video || !this.playback;

      if (waitingGlobals && !this.skipWaitingGlobals) {
        this.globalsManager.isAvailable().then(function () {
          return _this3.play();
        }, function () {
          return _this3.play();
        });
        this.skipWaitingGlobals = true;
      } else if (waitingPlayback) {
        this.listenToOnce(this, Events.WM_VIDEO_METADATA_LOADED, this.play);
      } else {
        waiting = false;
      }

      return waiting;
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return !!this.playback && this.playback.isPlaying();
    }
  }, {
    key: "setInitialTime",
    value: function setInitialTime(time) {
      var _this4 = this;

      if (!Browser.isChromecast && !Browser.isiOS && this.isPlaying()) this.seek(time);else this.listenToOnce(this.playback, Events$1.PLAYBACK_PLAY, function () {
        return _this4.seek(time);
      });
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.playback && this.playback.getDuration();
    }
  }, {
    key: "stop",
    value: function stop() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.actionsMetadata.stopEvent = options;
      this.stopAndClearPlayback();
      this.playback && this.trigger(Events$1.PLAYBACK_STOP, this.name, this.actionsMetadata.stopEvent);
    }
  }, {
    key: "stopAndClearPlayback",
    value: function stopAndClearPlayback() {
      if (this.playback) {
        this.playback.stop();
        this.currentTime = 0;
      }
    }
  }, {
    key: "mute",
    value: function mute() {
      this.playback && this.playback.mute();
    }
  }, {
    key: "unmute",
    value: function unmute() {
      this.playback && this.playback.unmute();
    }
  }, {
    key: "volume",
    value: function volume(value) {
      var _this5 = this;

      if (!this.playback) return;

      if (this.playback.isReady) {
        this.playback.volume(value);
        this.currentVolume = value;
      } else {
        this.listenToOnce(this.playback, Events$1.PLAYBACK_READY, function () {
          return _this5.volume(value);
        });
      }
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.currentVolume;
    }
  }, {
    key: "pause",
    value: function pause() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.actionsMetadata.pauseEvent = options;
      this.isPaused = true;
      this.playback && this.playback.pause();
    }
  }, {
    key: "switchAudioTrack",
    value: function switchAudioTrack(id) {
      if (this.useSingleAudioUrls) {
        var audioTrack = this.audioTracks.find(function (track) {
          return track.id === id;
        });
        if (!audioTrack || !this.currentAudioTrack || audioTrack.id === this.currentAudioTrack.id) return;
        this.currentAudio = audioTrack;
        this.load(this.selectedResource.getSingleAudioUrl(audioTrack));
        this.trigger(Events$1.PLAYBACK_AUDIO_CHANGED, audioTrack);
      } else {
        this.playback && this.playback.switchAudioTrack(id);
      }
    }
  }, {
    key: "getInitialAudioTrack",
    value: function getInitialAudioTrack() {
      var _ref = this.options.defaultAudio || {},
          language = _ref.language,
          role = _ref.role;

      var preferableAudioTrackWithRole = this.findAudioTrack(language, role);
      var preferableAudioTrack = this.findAudioTrack(language);
      var portugueseAudioTrack = this.findAudioTrack('por');

      var _this$audioTracks = _slicedToArray(this.audioTracks, 1),
          fallbackAudioTrack = _this$audioTracks[0];

      return preferableAudioTrackWithRole || preferableAudioTrack || portugueseAudioTrack || fallbackAudioTrack;
    }
  }, {
    key: "findAudioTrack",
    value: function findAudioTrack(language) {
      var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return this.audioTracks.find(function (track) {
        return track.language === language && track.role === role;
      });
    }
  }, {
    key: "seek",
    value: function seek(time) {
      var innerCurrentTime = this.playback && this.playback.getCurrentTime();
      var willSeek = Math.round(innerCurrentTime) !== Math.round(time);
      this.playback && willSeek && this.playback.seek(time);
    }
  }, {
    key: "getLastProgramDate",
    value: function getLastProgramDate() {
      if (this.playback.name === 'hls') return this.playback.getLastProgramDate();
      return -1;
    }
  }, {
    key: "getStartTimeOffset",
    value: function getStartTimeOffset() {
      var hasGetStartTimeOffset = this.playback && typeof this.playback.getStartTimeOffset === 'function';
      return hasGetStartTimeOffset ? this.playback.getStartTimeOffset() : 0;
    }
  }, {
    key: "isPip",
    value: function isPip(event) {
      this.onPip = event;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.playback) {
        this.stopListening(this.playback);
        this.playback.stop();
        this.playback.destroy();
        this.playback = null;
      }

      this.reportID && clearInterval(this.reportID);
      this.$el.remove();
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      this.video = video;
      this.validateRestrictedContent();
      this.setPlaybackConfig();
      this.initInnerPlayback();
    }
  }, {
    key: "setPlaybackConfig",
    value: function setPlaybackConfig() {
      if (!Browser.isSmartTvEnvironment) {
        setHLSJSConfig(this.options, this); // the configs for Shaka defined on settings should not be used used for LIVE content

        setShakaConfig(this.options, {
          forceDefaultConfigFromSettings: this.getPlaybackType() === Playback.LIVE
        });
      }
    }
  }, {
    key: "validateRestrictedContent",
    value: function validateRestrictedContent() {
      var unauthorizedRestrictedContent = this.video.adult && !this.options.allowRestrictedContent;
      unauthorizedRestrictedContent && this.onError(Errors.RESTRICTED_CONTENT);
    }
  }, {
    key: "onPlaybackReady",
    value: function onPlaybackReady() {
      var _this6 = this;

      if (this.playback.isReady) this.ready();else this.playback.once(Events$1.PLAYBACK_READY, function () {
        return _this6.ready();
      });
    }
  }, {
    key: "onVideoMetadataError",
    value: function onVideoMetadataError(error) {
      this.onError(error, Errors.PLAYLIST_LOAD_ERROR);
    }
  }, {
    key: "onResourceLoadError",
    value: function onResourceLoadError(error) {
      var resourceLoadError = _objectSpread2(_objectSpread2({}, Errors.RESOURCE_LOAD_ERROR), {}, {
        description: "".concat(Errors.RESOURCE_LOAD_ERROR.description, " ").concat(error.message || convertToString(error)),
        raw: error
      });

      this.onError(error, resourceLoadError);
    }
  }, {
    key: "onError",
    value: function onError(error) {
      var overrideError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      Log.warn(this.name, 'id playback error:', error);
      this.playbackError = getPlaybackError(error, this.options, this.video);
      var isDefaultError = this.playbackError.code === Errors.DEFAULT_ERROR.code;
      var shouldOverrideDefaultError = isDefaultError && overrideError;
      if (shouldOverrideDefaultError) this.playbackError = overrideError;
      var errorOptions = {
        useCodePrefix: false
      };
      this.trigger(Events$1.PLAYBACK_ERROR, this.createError(this.playbackError, errorOptions));
    }
  }, {
    key: "onResourceReady",
    value: function onResourceReady(video) {
      this.video = video;
      this._resourceReady = true;
      this.loadingResource = false; // smartTVs recover drm_config from the options
      // because of this, these options are being set on the configureSmartTvResourceParams method

      Browser.isSmartTvEnvironment && this.configureSmartTvResourceParams();

      if (this.useSingleAudioUrls) {
        this.currentAudio = this.getInitialAudioTrack();
        this.trigger(Events$1.PLAYBACK_AUDIO_AVAILABLE, this.audioTracks);
      }

      this.setupAuthorized();
    }
  }, {
    key: "setupAuthorized",
    value: function setupAuthorized() {
      this.trigger(Events$1.Custom.PLAYBACK_AUTHORIZED);
    }
  }, {
    key: "setupVideoResource",
    value: function setupVideoResource(url) {
      this.setupPlayback(url);
      this.onPlaybackReady();
    }
  }, {
    key: "configureSmartTvResourceParams",
    value: function configureSmartTvResourceParams() {
      var isEncrypted = this.video && this.video.encrypted;
      var contentProtection = this.selectedResource && this.selectedResource.contentProtection;
      var drmConfig = isEncrypted && contentProtection ? getDRMConfig(this.video, this.options.httpOnly) : {};
      this.playback && this.playback.configure(_objectSpread2(_objectSpread2({
        contentProtection: contentProtection
      }, drmConfig), {}, {
        shakaConfiguration: _objectSpread2(_objectSpread2({}, this.options.shakaConfiguration), drmConfig.shakaConfiguration)
      }));
    }
  }, {
    key: "getPlaybackType",
    value: function getPlaybackType() {
      if (this.video) return this.video.type === 'Live' || this.video.isLive ? 'live' : 'vod';
    }
  }, {
    key: "initInnerPlayback",
    value: function initInnerPlayback(srcUrl) {
      this.playback = createPlayback.call(this, srcUrl, this.selectedResource, this.blackResourceUrl);
      if (this.playback.name === 'no_op') return this.onError(Errors.DEVICE_NOT_SUPPORTED);
      this.bindPlaybackEvents();
      this.renderInnerPlayback();
      this.onInnerPlaybackReady();
      this.options.autoPlay && this.startAutoPlayCheck();
    }
  }, {
    key: "startAutoPlayCheck",
    value: function startAutoPlayCheck() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$autoPlay = _ref2.autoPlay,
          autoPlay = _ref2$autoPlay === void 0 ? this.options.autoPlay : _ref2$autoPlay;

      this.checkingAutoplayPermission = true;
      autoplayManager.onAutoplayAvailable(this.onAutoplaySuccess.bind(this), _objectSpread2(_objectSpread2({}, this.options), {}, {
        autoPlay: autoPlay
      }), this.onAutoplayFail.bind(this));
    }
  }, {
    key: "onAutoplaySuccess",
    value: function onAutoplaySuccess() {
      var _this7 = this;

      autoplayManager.canAutoPlayUnmuted ? nextTick(function () {
        return _this7.play();
      }) : this.playMuted();
    }
  }, {
    key: "onAutoplayFail",
    value: function onAutoplayFail() {
      this.trigger(Events.WM_AUTOPLAY_BLOCKED);
    }
  }, {
    key: "playMuted",
    value: function playMuted() {
      var _this8 = this;

      this.mutedAutoplay = true; // force muted autoplay to avoid issues on Safari (iOS/Mac)

      if (this.playback) {
        this.playback.volume(0);
        this.currentVolume = 0;
      }

      nextTick(function () {
        return _this8.play();
      });
    }
  }, {
    key: "setupPlayback",
    value: function setupPlayback() {
      var srcUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedResource.url;
      var singleAudioUrl = this.useSingleAudioUrls && this.selectedResource.getSingleAudioUrl(this.currentAudioTrack);
      var url = singleAudioUrl || srcUrl;
      this.trigger(Events$1.PLAYBACK_STATS_ADD, {
        midia: this.options.src,
        url: url
      });
      this.updateSrc(url);
      this._playbackWasBuilt = true;
      this.trigger(Events.WM_PLAYBACK_BUILT);
      if (this.options.selectedLevel) try {
        this.play();
      } catch (e) {
        Log.warn(this.name, 'play()', e);
      } else if (this.onPip) this.playWhenReady();
    }
  }, {
    key: "updateSrc",
    value: function updateSrc(srcUrl) {
      typeof this.playback.load === 'function' && this.playback.load(srcUrl);
      _typeof(this.playback.options) === 'object' && (this.playback.options.src = srcUrl);
      typeof this.playback._setupSrc === 'function' && this.playback._setupSrc(srcUrl);
      typeof this.playback.setupSrc === 'function' && this.playback.setupSrc(srcUrl);
      this.prepareInnerPlaybackToPlay();
    }
  }, {
    key: "prepareInnerPlaybackToPlay",
    value: function prepareInnerPlaybackToPlay() {
      var _this9 = this;

      var innerPlaybackNeedsSetup = this.playback && typeof this.playback._setup === 'function';
      if (!innerPlaybackNeedsSetup || this._innerPlaybackSetupDone) return;
      this._playbackWasBuilt ? this.playback._setup() : this.listenToOnce(this, Events.WM_PLAYBACK_BUILT, function () {
        _this9.configureInnerPlaybackDRM();

        _this9.playback._setup();
      });
      this._innerPlaybackSetupDone = true;
    }
  }, {
    key: "configureInnerPlaybackDRM",
    value: function configureInnerPlaybackDRM() {
      if (this.isEncrypted) {
        var drmConfig = getDRMConfig(this.video, this.options.httpOnly);
        this.playback.options.fairplay = drmConfig.fairplay;
        if (this.playback.name === 'dash_shaka_playback') this.playback._options.shakaConfiguration.drm = _objectSpread2(_objectSpread2({}, drmConfig.shakaConfiguration.drm), this.playback._options.shakaConfiguration.drm);
      }
    }
  }, {
    key: "recreatePlayback",
    value: function recreatePlayback(srcUrl) {
      var isFallbackSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.playback) {
        this.initInnerPlayback(srcUrl);
        return true;
      }

      var canPlay = this.playback.constructor.canPlay(srcUrl, '', this.isEncrypted);
      var forceCreatePlayback = this.playback.name === 'flashls' || this.playback.name === 'hls_fairplay_playback';

      if (isFallbackSource || !canPlay || forceCreatePlayback) {
        this.stopListening(this.playback);
        this.playback.destroy();
        this.initInnerPlayback(srcUrl);
        return true;
      }
    }
  }, {
    key: "bindPlaybackEvents",
    value: function bindPlaybackEvents() {
      this.listenTo(this.playback, Events$1.PLAYBACK_SETTINGSUPDATE, this.settingsupdate);
      this.listenTo(this.playback, Events$1.PLAYBACK_LOADEDMETADATA, this.loadedmetadata);
      this.listenTo(this.playback, Events$1.PLAYBACK_PLAYBACKSTATE, this.playbackstate);
      this.listenTo(this.playback, Events$1.PLAYBACK_ERROR, this.onInnerPlaybackError);
      this.listenTo(this.playback, Events$1.PLAYBACK_PROGRESS, this.progress);
      this.listenTo(this.playback, Events$1.PLAYBACK_TIMEUPDATE, this.timeupdate);
      this.listenTo(this.playback, Events$1.PLAYBACK_PLAY_INTENT, this.playintent);
      this.listenTo(this.playback, Events$1.PLAYBACK_PLAY, this.playing);
      this.listenTo(this.playback, Events$1.PLAYBACK_PAUSE, this.paused);
      this.listenTo(this.playback, Events$1.PLAYBACK_SEEK, this.onSeek);
      this.listenTo(this.playback, Events$1.PLAYBACK_SEEKED, this.onSeeked);
      this.listenTo(this.playback, Events$1.PLAYBACK_STATS_ADD, this.statsAdd);
      this.listenTo(this.playback, Events$1.PLAYBACK_DVR, this.onDvr);
      this.listenTo(this.playback, Events$1.PLAYBACK_BITRATE, this.updateBitrate);
      this.listenTo(this.playback, Events$1.PLAYBACK_BUFFERFULL, this.bufferfull);
      this.listenTo(this.playback, Events$1.PLAYBACK_BUFFERING, this.onBuffering);
      this.listenTo(this.playback, Events$1.PLAYBACK_ENDED, this.ended);
      this.listenTo(this.playback, Events$1.PLAYBACK_AUDIO_CHANGED, this.onAudioChanged);
      this.listenTo(this.playback, Events$1.PLAYBACK_AUDIO_AVAILABLE, this.onAudioAvailable);
    }
  }, {
    key: "playbackstate",
    value: function playbackstate(state) {
      this.trigger(Events$1.PLAYBACK_PLAYBACKSTATE, state);
    }
  }, {
    key: "updateBitrate",
    value: function updateBitrate(newBitrate) {
      this.trigger(Events$1.PLAYBACK_BITRATE, newBitrate);
    }
  }, {
    key: "progress",
    value: function progress(progressObj) {
      this.trigger(Events$1.PLAYBACK_PROGRESS, progressObj);
    }
  }, {
    key: "statsAdd",
    value: function statsAdd(newMetric) {
      this.trigger(Events$1.PLAYBACK_STATS_ADD, newMetric);
    }
  }, {
    key: "onDvr",
    value: function onDvr(isOnDvr) {
      this.trigger(Events$1.PLAYBACK_DVR, isOnDvr);
    }
  }, {
    key: "timeupdate",
    value: function timeupdate(timeProgress) {
      if (!timeProgress.current) return;
      this.currentTime = timeProgress.current;
      this.duration = timeProgress.total;
      this.trigger(Events$1.PLAYBACK_TIMEUPDATE, _objectSpread2(_objectSpread2({}, timeProgress), {}, {
        playbackType: this.getPlaybackType()
      }));
    }
  }, {
    key: "ready",
    value: function ready() {
      this._isReady = true;
      this.settingsupdate();
      this.trigger(Events.WM_PLAYBACK_WILL_PLAY, this.name);
    }
  }, {
    key: "onSeek",
    value: function onSeek() {
      this.trigger(Events$1.PLAYBACK_SEEK, this.name);
    }
  }, {
    key: "onSeeked",
    value: function onSeeked() {
      this.trigger(Events$1.PLAYBACK_SEEKED, this.name);
      this.isPaused && this.trigger(Events$1.PLAYBACK_PAUSE, this.name);
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      this.trigger(Events$1.PLAYBACK_BUFFERING, this.name);
    }
  }, {
    key: "bufferfull",
    value: function bufferfull() {
      this.trigger(Events$1.PLAYBACK_BUFFERFULL, this.name);
    }
  }, {
    key: "settingsupdate",
    value: function settingsupdate() {
      var playbackType = this.getPlaybackType();
      if (!playbackType) return;

      if (playbackType === 'ad') {
        this.settings = this.playback.settings;
      } else {
        this.settings = _objectSpread2({}, this.defaultSettings);
        if (playbackType !== 'vod') if (this.playback && !this.playback.dvrEnabled) this.settings.seekEnabled = false;
      }

      this.trigger(Events$1.PLAYBACK_SETTINGSUPDATE);
    }
  }, {
    key: "loadedmetadata",
    value: function loadedmetadata(metadata) {
      this.trigger(Events$1.PLAYBACK_LOADEDMETADATA, metadata);
      this.checkInitialSeek();
    }
  }, {
    key: "checkInitialSeek",
    value: function checkInitialSeek() {
      var initialPosition = this.isLive ? this.options.liveStartTime && this.liveInitialPosition : this.options.resumeAt || seekStringToSeconds();
      initialPosition && initialPosition > 0 && this.setInitialTime(initialPosition);
    }
  }, {
    key: "setupSession",
    value: function setupSession() {
      session.startSession(this.options.playerId);
    }
  }, {
    key: "ended",
    value: function ended() {
      var _this10 = this;

      // calling stop here to force hls.js update source on next play
      this.stopAndClearPlayback();
      this.trigger(Events$1.PLAYBACK_ENDED, this.name);
      nextTick(function () {
        return _this10.setupSession();
      });
    }
  }, {
    key: "onAudioChanged",
    value: function onAudioChanged(audioTrack) {
      if (this.useSingleAudioUrls) return;
      this.currentAudio = audioTrack;
      this.trigger(Events$1.PLAYBACK_AUDIO_CHANGED, audioTrack);
    }
  }, {
    key: "onAudioAvailable",
    value: function onAudioAvailable(audioTracks) {
      if (this.useSingleAudioUrls) return;
      this.currentAudio = this.playback.currentAudioTrack;
      this.trigger(Events$1.PLAYBACK_AUDIO_AVAILABLE, audioTracks);
      var initialAudioTrack = this.getInitialAudioTrack();
      initialAudioTrack && this.playback.switchAudioTrack(initialAudioTrack.id);
    }
  }, {
    key: "playintent",
    value: function playintent() {
      this.trigger(Events$1.PLAYBACK_PLAY_INTENT, this.name);
    }
  }, {
    key: "playing",
    value: function playing() {
      this.isPaused = false;
      this.trigger(Events$1.PLAYBACK_PLAY, this.name, this.actionsMetadata.playEvent);
    }
  }, {
    key: "paused",
    value: function paused() {
      this.isPaused = true;
      this.trigger(Events$1.PLAYBACK_PAUSE, this.name, this.actionsMetadata.pauseEvent);
    }
  }, {
    key: "onInnerPlaybackError",
    value: function onInnerPlaybackError() {
      var playerError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var resourceHasFallback = this.selectedResource.hasFallbackSource();
      var errorIsRecoverable = checkRecoverableError(this.playback.name, playerError);

      if (!this.isRenewingResource) {
        if (errorIsRecoverable && resourceHasFallback) return this.useFallbackSource(playerError);
        return this.renewResource(playerError);
      }

      this.trigger(Events$1.PLAYBACK_ERROR, playerError);
    }
  }, {
    key: "useFallbackSource",
    value: function useFallbackSource(playerError) {
      var code = playerError.code,
          description = playerError.description;
      Log.info(this.name, "Will select fallback source, previous: ".concat(this.srcUrl));
      this.trigger(Events.WILL_SELECT_FALLBACK_SOURCE, {
        recoveredError: JSON.stringify({
          code: code,
          description: description
        }),
        currentSrc: this.srcUrl
      });
      this.selectedResource.nextFallbackSource();
      this.trigger(Events.WILL_CHANGE_SOURCE, {
        source: this.selectedResource.url,
        errorCode: code,
        errorMessage: description
      });
      this.trigger(Events.FALLBACK_SOURCE_SELECTED, {
        currentSrc: this.selectedResource.url
      });
      Log.info(this.name, "Fallback source selected: ".concat(this.srcUrl));
    }
  }, {
    key: "onFallbackSourceSelected",
    value: function onFallbackSourceSelected(_ref3) {
      var currentSrc = _ref3.currentSrc;
      this.load(currentSrc);
    }
  }, {
    key: "renewResource",
    value: function renewResource(_ref4) {
      var code = _ref4.code;
      this.initPlaybackRestart();
      this.isRenewingResource = true;
      this.trigger(Events.WILL_RENEW_RESOURCE, {
        renewReason: code
      });
      this.listenToOnce(this, Events$1.PLAYBACK_PLAY, this.onResourceRenewed);
    }
  }, {
    key: "onResourceRenewed",
    value: function onResourceRenewed() {
      this.isRenewingResource = false;
    }
  }, {
    key: "onInnerPlaybackReady",
    value: function onInnerPlaybackReady() {
      var _this11 = this;

      this.trigger(Events$1.PLAYBACK_READY, this.name); // wait for nextTick (after ready event) to trigger can play event

      nextTick(function () {
        return _this11.trigger(Events.WM_PLAYBACK_CAN_PLAY, _this11.name);
      });
    }
  }, {
    key: "load",
    value: function load(src) {
      this.initPlaybackRestart();
      this.setupVideoResource(src);
    }
  }, {
    key: "initPlaybackRestart",
    value: function initPlaybackRestart() {
      this._isReady = false;
      this._innerPlaybackSetupDone = false;
      this._playbackWasBuilt = false;
      this.resetOptions();
      this.isRestarting = true;
    }
  }, {
    key: "resetOptions",
    value: function resetOptions() {
      var updatedOptions = {
        resumeAt: this.currentTime
      };
      this.currentAudio && (updatedOptions.defaultAudio = {
        language: this.currentAudio.language,
        role: this.currentAudio.role
      });
      this.currentSubtitle && (updatedOptions.currentSubtitle = this.currentSubtitle.language);
      this.playback && this.playback.configure($.extend(this.options, updatedOptions));
    }
  }, {
    key: "renderInnerPlayback",
    value: function renderInnerPlayback() {
      this.playback.render();
      this.playback.el.id = this.cid;
      this.playback.el.controlsList = 'nodownload noremoteplayback';
      this.playback.el.removeAttribute('src');
      this.$el.html(this.playback.el);
      var styleOption = {
        baseUrl: this.options.baseUrl,
        playerId: this.options.playerId
      };
      var style = Styler.getStyleFrom(css_248z.toString(), styleOption);
      this.$el.append(style[0]);
      var coverViewportClass = 'cover-viewport';
      this.options.preventBlackBars ? this.$el.addClass(coverViewportClass) : this.$el.removeClass(coverViewportClass);
    }
  }]);

  return IdPlayback;
}(Playback);

IdPlayback.canPlay = function (resource) {
  return isVideoId(resource.toString());
};

var Logger = Log$1.getInstance();

var VideoMetadata = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(VideoMetadata, _ContainerPlugin);

  var _super = _createSuper(VideoMetadata);

  _createClass(VideoMetadata, [{
    key: "name",
    get: function get() {
      return 'video_metadata';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "callbackPrefix",
    get: function get() {
      return 'wmPlayerPlaylistLoaded';
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "metadataOptions",
    get: function get() {
      return {
        selectedLevel: this.options.selectedLevel,
        preferredLevel: this.options.preferredLevel,
        preferredCDN: this.options.cdn,
        env: this.options.env,
        profile: this.options.maxQualityLevel,
        getPlayerType: this.options.overrides && this.options.overrides.getPlayerType
      };
    }
  }]);

  function VideoMetadata(container) {
    var _this;

    _classCallCheck(this, VideoMetadata);

    _this = _super.call(this, container);
    if (!_this.options.src || !isVideoId(_this.options.src)) return _possibleConstructorReturn(_this);
    autoplayManager.onAutoplayAvailable(_this.onAutoPlayAvailable.bind(_assertThisInitialized(_this)), _this.options, _this.onAutoPlayDisabled.bind(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(VideoMetadata, [{
    key: "onAutoPlayAvailable",
    value: function onAutoPlayAvailable() {
      this.listenToOnce(this.playback, Events.WM_VIDEO_METADATA_REQUEST_COMPLETE, this.parseMetadataRequest);
    }
  }, {
    key: "onAutoPlayDisabled",
    value: function onAutoPlayDisabled() {
      var _this2 = this;

      this.setRequestData();
      this.load().then(function (video) {
        return _this2.playback.trigger(Events.WM_VIDEO_METADATA_LOADED, video);
      }, function (error) {
        return _this2.playback.trigger(Events.WM_VIDEO_METADATA_ERROR, error);
      });
    }
  }, {
    key: "setRequestData",
    value: function setRequestData() {
      var videoId = this.options.src;
      var env = this.options.env;
      this.callback = this.callbackPrefix + this.options.playerId + videoId;
      this.url = env.playlistTemplate({
        videoId: videoId,
        callback: this.callback
      });
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      Logger.info(this.name, 'loading playlist from:', this.url);
      return Ajax.jsonp({
        callbackName: this.callback,
        url: this.url
      }).then(function (data) {
        return _this3.parsePlaylist(data);
      });
    }
  }, {
    key: "parsePlaylist",
    value: function parsePlaylist(data) {
      var defer = new $$1.Deferred();

      if (this.isValidPlaylist(data)) {
        var video = this.getMetadataModel(data.videos[0], this.metadataOptions);
        defer.resolve(video);
      } else {
        Logger.warn(this.name, 'error on playlist: ', data);
        defer.reject(data);
      }

      return defer;
    }
  }, {
    key: "isValidPlaylist",
    value: function isValidPlaylist(playlist) {
      return !!playlist && !!playlist.videos && playlist.videos.length > 0;
    }
  }, {
    key: "getMetadataModel",
    value: function getMetadataModel(metadata, metadataOptions) {
      var video = new Video(metadata, metadataOptions);
      Logger.info(this.name, 'video:', video);
      return video;
    }
  }, {
    key: "parseMetadataRequest",
    value: function parseMetadataRequest(_ref) {
      var metadata = _ref.metadata;
      var video = this.getMetadataModel(metadata, this.metadataOptions);
      this.playback.trigger(Events.WM_VIDEO_METADATA_LOADED, video);
    }
  }]);

  return VideoMetadata;
}(ContainerPlugin);

var r={d:function(e,t){for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]});},o:function(r,e){return Object.prototype.hasOwnProperty.call(r,e)}},e={};r.d(e,{U:function(){return o}});var t=function(r){return !r||Number.isNaN(r)?1:Math.random()+r};var n=function(r){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:-1;return r.includes(e)},o=function(r){var e=r.action,o=r.maxAttempts,i=void 0===o?3:o,a=r.baseDelay,c=void 0===a?100:a,u=r.backOffFactor,f=void 0===u?2:u,s=r.retryableErrors,y=void 0===s?null:s,d=0,l=[];return function r(){return e&&"function"==typeof e?e().then((function(r){return {retryResponse:r,retryHistory:l}})).catch((function(e){if(y&&!n(y,e.statusCode))return Promise.reject({retryError:e,retryHistory:l});var o,a,u;if(l.push((o={},a="attempt_".concat(d),u=e,a in o?Object.defineProperty(o,a,{value:u,enumerable:!0,configurable:!0,writable:!0}):o[a]=u,o)),d===i)return Promise.reject({retryError:e,retryHistory:l});d++;var s=Math.pow(f,d-1)*c,m=s*t(.5);return console.log("Retrying...\nIf the retries fail we delay the next attempt in ".concat(s/1e3," seconds\n Fuzz factor for retry: ").concat(m)),new Promise((function(e){setTimeout((function(){e(r());}),m);}))})):Promise.reject({retryError:"Action must be defined and a function",retryHistory:l})}()},i=e.U;

var CDNRouter = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(CDNRouter, _ContainerPlugin);

  var _super = _createSuper(CDNRouter);

  _createClass(CDNRouter, [{
    key: "name",
    get: function get() {
      return 'cdn_router';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    }
  }, {
    key: "retryableErrors",
    get: function get() {
      return [0, 500, 501, 502, 503, 504];
    }
  }, {
    key: "retrySettings",
    get: function get() {
      var PlayerSettings = window.WM && window.WM.Settings || {};
      var maxAttempts = PlayerSettings.maxAttempts,
          baseDelay = PlayerSettings.baseDelay,
          backOffFactor = PlayerSettings.backOffFactor;
      return {
        maxAttempts: maxAttempts,
        baseDelay: baseDelay,
        backOffFactor: backOffFactor
      };
    }
  }]);

  function CDNRouter(container) {
    var _this;

    _classCallCheck(this, CDNRouter);

    _this = _super.call(this, container);
    autoplayManager.onAutoplayAvailable(_this.onAutoPlayAvailable.bind(_assertThisInitialized(_this)), _this.options, _this.onAutoPlayDisabled.bind(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(CDNRouter, [{
    key: "onAutoPlayAvailable",
    value: function onAutoPlayAvailable() {
      this.loadMetadataFromRequest = true;
      this.loadResource();
    }
  }, {
    key: "onAutoPlayDisabled",
    value: function onAutoPlayDisabled() {
      this.loadMetadataFromRequest = false;
      this.listenToOnce(this.playback, Events.WM_PLAY_REQUESTED_READY, this.loadResource);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.listenTo(this.playback, Events.WILL_RENEW_RESOURCE, this.loadResource);
    }
  }, {
    key: "loadResource",
    value: function loadResource() {
      var _this2 = this;

      return this.createPayload().then(function (payload) {
        return _this2.getResource(payload);
      }).then(function (resource) {
        return _this2.onResourceLoaded(resource);
      })["catch"](function () {
        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var errorToSend = _this2.mountAjaxErrorBody(error);

        try {
          errorToSend = _objectSpread2(_objectSpread2({}, errorToSend), JSON.parse(error.xhr.response));
        } catch (e) {
          /* ignore parse error */
        }

        _this2.onResourceError(errorToSend);
      });
    }
  }, {
    key: "createPayload",
    value: function createPayload() {
      var _this3 = this;

      return new Promise(function (resolve) {
        /* eslint-disable camelcase */
        var data = {
          player_type: Video.getPlayerType(),
          video_id: "".concat(_this3.options.src),
          quality: _this3.options.maxQualityLevel || 'max',
          content_protection: Video.getDRMProtocol(),
          vsid: session.getVideoSessionId(_this3.options.playerId),
          tz: iso8601TimezoneOffset()
        };
        /* eslint-enable camelcase */
        // Force using flat URL for chromecast because of the s3.glbimg.com (third-party domain)

        Browser.isChromecast && (data.flt = true);
        typeof _this3.options.httpOnly === 'boolean' && (data.ho = _this3.options.httpOnly);
        isTimestampOnHashNeeded && (data.ts = Math.trunc(getCurrentTime()));
        if (_this3.options.allowLocation) _this3.getLocation().then(function (coordinates) {
          resolve(_objectSpread2(_objectSpread2({}, data), {}, {
            lat: "".concat(coordinates.latitude),
            "long": "".concat(coordinates.longitude)
          }));
        })["catch"](function () {
          return resolve(data);
        });else resolve(data);
      });
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      var _this4 = this;

      if (Environment.isGloboiDomain && this.options.lat && this.options["long"]) {
        var coordinates = {
          latitude: this.options.lat,
          longitude: this.options["long"]
        };
        this.container.trigger(Events.WM_LOCATION_AVAILABLE, coordinates);
        return new Promise(function (resolve) {
          return resolve(coordinates);
        });
      }

      return new Promise(function (resolve, reject) {
        Location.getLocation().then(function (location) {
          var coordinates = {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude
          };

          _this4.container.trigger(Events.WM_LOCATION_AVAILABLE, coordinates);

          resolve(coordinates);
        })["catch"](function (error) {
          Log$1.warn(_this4.name, 'Failed to get location. We make the request to /cdn without passing lat/long params', error);
          reject(error);
        });
      });
    }
  }, {
    key: "getResource",
    value: function getResource(payload) {
      var _this5 = this;

      return this.sendRequestWithRetry(this.options.env.CDNRouterHost, payload).then(function (_ref) {
        var retryResponse = _ref.retryResponse,
            retryHistory = _ref.retryHistory;

        _this5.onResourceRequestFinished(retryHistory, retryHistory.length + 1, false);

        return retryResponse;
      })["catch"](function (_ref2) {
        var retryError = _ref2.retryError,
            retryHistory = _ref2.retryHistory;

        var errorIsRetriable = _this5.retryableErrors.includes(retryError.statusCode);

        if (!errorIsRetriable) {
          _this5.onResourceRequestFinished(retryHistory, Math.max(retryHistory.length, 1), false);

          return Promise.reject(retryError);
        }

        return _this5.sendRequest(_this5.options.env.CDNRouterFallbackHost, payload).then(function (response) {
          _this5.onResourceRequestFinished(retryHistory, retryHistory.length + 1, true);

          return response;
        })["catch"](function (error) {
          _this5.onResourceRequestFinished([].concat(_toConsumableArray(retryHistory), [retryError]), retryHistory.length + 1, true);

          return Promise.reject(error);
        });
      });
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(url, body) {
      var lockId = session.getLockId(this.options.playerId);
      var ajaxSettings = {
        url: url,
        type: 'POST',
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify(body)
      };
      this.options.token && (ajaxSettings.headers = {
        Authorization: "Bearer ".concat(this.options.token)
      });
      lockId && (ajaxSettings.headers = _objectSpread2(_objectSpread2({}, ajaxSettings.headers), {}, {
        'X-Session-ID': lockId
      }));
      return this.executeAjaxRequest(ajaxSettings);
    }
  }, {
    key: "sendRequestWithRetry",
    value: function sendRequestWithRetry(url, body) {
      var _this6 = this;

      var _this$retrySettings = this.retrySettings,
          maxAttempts = _this$retrySettings.maxAttempts,
          baseDelay = _this$retrySettings.baseDelay,
          backOffFactor = _this$retrySettings.backOffFactor;
      var retryParameters = {
        action: function action() {
          return _this6.sendRequest(url, body);
        },
        maxAttempts: maxAttempts,
        baseDelay: baseDelay,
        backOffFactor: backOffFactor,
        retryableErrors: this.retryableErrors
      };
      return i(retryParameters);
    }
  }, {
    key: "executeAjaxRequest",
    value: function executeAjaxRequest(ajaxSettings) {
      return new Promise(function (resolve, reject) {
        $$1.ajax(ajaxSettings).then(function (resource) {
          resolve({
            resource: resource
          });
        }, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var _args = _objectSpread2({}, args),
              xhr = _args[0],
              status = _args[1],
              error = _args[2]; // destruct ajax params


          var statusCode = xhr.status;
          reject({
            xhr: xhr,
            status: status,
            error: error,
            statusCode: statusCode
          });
        });
      });
    }
  }, {
    key: "mountAjaxErrorBody",
    value: function mountAjaxErrorBody(errorData) {
      var xhr = errorData.xhr,
          status = errorData.status,
          error = errorData.error;
      return {
        status: status,
        error: xhr && xhr.statusText || error,
        url: xhr && xhr.responseURL || this.options.env.CDNRouterHost,
        http_status_code: xhr && xhr.status // eslint-disable-line camelcase

      };
    }
  }, {
    key: "onResourceLoaded",
    value: function onResourceLoaded(_ref3) {
      var _this7 = this;

      var _ref3$resource = _ref3.resource,
          resource = _ref3$resource === void 0 ? {} : _ref3$resource;
      resource.sources && resource.sources[0].token && session.storeLockId(this.options.playerId, resource.sources[0].token);
      if (this.loadMetadataFromRequest) this.playback.trigger(Events.WM_VIDEO_METADATA_REQUEST_COMPLETE, resource);
      setTimeout(function () {
        return _this7.playback.trigger(Events.WM_RESOURCE_LOADED, resource);
      });
    }
  }, {
    key: "onResourceError",
    value: function onResourceError(error) {
      if (error.message === 'CDN not available') return this.playback.trigger(Events.WM_WROOM_WAITING, error);
      this.playback.trigger(Events.WM_RESOURCE_ERROR, error);
    }
  }, {
    key: "onResourceRequestFinished",
    value: function onResourceRequestFinished(retries, totalAttempts, usedFallback) {
      this.container.trigger(Events.WM_RESOURCE_REQUEST_STATS, {
        retries: retries,
        totalAttempts: totalAttempts,
        usedFallback: usedFallback
      });
    }
  }]);

  return CDNRouter;
}(ContainerPlugin);

var MediaResource = /*#__PURE__*/function () {
  _createClass(MediaResource, [{
    key: "cdn",
    get: function get() {
      return this.resourceCDN;
    }
  }, {
    key: "isGloboCDN",
    get: function get() {
      return this.cdn === DEFAULT_CDN;
    }
  }, {
    key: "url",
    get: function get() {
      return this.shouldPlayWithDAI ? this.signDAIUrl(this.daiURL) : this.originalURL;
    }
  }, {
    key: "shouldPlayWithDAI",
    get: function get() {
      return !!(this.dai && this.daiURL && this.daiEnabled);
    }
  }, {
    key: "forceGloboCDN",
    get: function get() {
      // iOS Browsers (Safari and Chrome) does not accept third party cookies.
      // This makes it impossible to use third-party CDNs without a cookieless solution.
      // The cookieless solution provided by Akamai is delivered only for Safari currently.
      return Browser.isiOS && !Browser.isSafari || Browser.isSmartTvEnvironment;
    }
  }, {
    key: "useFlatURL",
    get: function get() {
      return Browser.preventUsingCookies && this.isGloboCDN || this.dai;
    }
  }, {
    key: "subtitles",
    get: function get() {
      return this._buildSubtitles('srt', this.source.subtitles || {});
    }
  }, {
    key: "subtitlesWebVTT",
    get: function get() {
      return this._buildSubtitles('webvtt', this.source.subtitles_webvtt || {});
    }
  }, {
    key: "sourceIndex",
    get: function get() {
      return this.sources.indexOf(this.source);
    }
  }, {
    key: "fallbackSourceIndex",
    get: function get() {
      return this.sourceIndex + 1;
    }
  }]);

  function MediaResource(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, MediaResource);

    if (json && json.sources && json.resource) {
      this.options = options;
      this.sources = json.sources;
      this.contentProtection = json.resource.content_protection || {};
      this.signal = json.resource.signal;
      this.thumbUrl = json.thumbs_preview_base_url;
      this.rawData = json;
      this.daiEnabled = false;
      this.options.forceDRMServer && this.forceDRMServer();
      this.setExpirationTime();
      this.useSource(this.sources[0]);
    }
  }

  _createClass(MediaResource, [{
    key: "setExpirationTime",
    value: function setExpirationTime() {
      var currentTime = new Date().getTime();
      this.sources.forEach(function (source) {
        source.expirationDate = source.expiration_time && currentTime + source.expiration_time;
      });
    }
  }, {
    key: "hasFallbackSource",
    value: function hasFallbackSource() {
      if (this.fallbackSourceIndex >= this.sources.length) return false;
      var currentTime = new Date().getTime();
      var fallbackSource = this.sources[this.fallbackSourceIndex];
      return currentTime < (fallbackSource === null || fallbackSource === void 0 ? void 0 : fallbackSource.expirationDate);
    }
  }, {
    key: "nextFallbackSource",
    value: function nextFallbackSource() {
      var fallbackSource = this.sources[this.fallbackSourceIndex];
      this.hasFallbackSource() && this.useSource(fallbackSource);
    }
  }, {
    key: "useSource",
    value: function useSource(source) {
      this.source = source;
      this.singleAudioUrls = source.single_audio_urls;
      this.urlParts = source.url_parts || {};
      this.originalURL = source.url_template;
      this.resourceCDN = source.cdn;
      this.resourcePOP = source.pop;
      this.dai = source.dai;
      this.assetKey = source.asset_key;
      this.token = source.token;
      this.audioTracksForSingleAudioUrls = Object.keys(source.single_audio_urls).map(function (language, idx) {
        return {
          id: String(idx),
          language: language,
          label: language,
          kind: 'main'
        };
      });
    }
  }, {
    key: "getSingleAudioUrl",
    value: function getSingleAudioUrl(audioTrack) {
      return audioTrack && this.singleAudioUrls[audioTrack.language];
    }
  }, {
    key: "_buildSubtitles",
    value: function _buildSubtitles(type, subtitles) {
      return Object.keys(subtitles).map(function (language, idx) {
        return {
          id: String(idx),
          language: language,
          label: language,
          type: type,
          url: subtitles[language]
        };
      });
    }
  }, {
    key: "setDAIURL",
    value: function setDAIURL(url) {
      this.daiURL = url;
    }
  }, {
    key: "enableDAI",
    value: function enableDAI() {
      this.daiEnabled = true;
    }
  }, {
    key: "disableDAI",
    value: function disableDAI() {
      this.daiEnabled = false;
    }
  }, {
    key: "signDAIUrl",
    value: function signDAIUrl(daiUrl) {
      var originalInterpolationRegex = template.settings.interpolate;
      template.settings.interpolate = /\{\{(.+?)\}\}/g;
      var daiTemplate = template("".concat(this.originalURL, "{{ queryString }}"));
      var match = daiUrl.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/); // eslint-disable-line no-useless-escape

      var daiVideoUrl = {
        queryString: match[6] || ''
      };
      var urlParams = {
        queryString: daiVideoUrl.queryString
      };
      var signedUrl = daiTemplate(urlParams);
      template.settings.interpolate = originalInterpolationRegex;
      return signedUrl;
    }
  }, {
    key: "forceDRMServer",
    value: function forceDRMServer() {
      this.contentProtection.server = this.options.forceDRMServer;
    }
  }]);

  return MediaResource;
}();

var Transmission = function Transmission(json) {
  _classCallCheck(this, Transmission);

  this.id = json.transmission_id;
  this.affiliate = {
    code: json.affiliate_code
  };
  this.signal = json.signal;
};

var Resource = /*#__PURE__*/function (_ContainerPlugin) {
  _inherits(Resource, _ContainerPlugin);

  var _super = _createSuper(Resource);

  function Resource() {
    _classCallCheck(this, Resource);

    return _super.apply(this, arguments);
  }

  _createClass(Resource, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.idPlayback = this.playback;
      this.listenTo(this.playback, Events.WM_VIDEO_METADATA_LOADED, this.onMetadataLoaded);
      this.listenTo(this.playback, Events.WM_RESOURCE_LOADED, this.onResourceLoaded);
      this.listenTo(this.playback, Events.WM_RESOURCE_SELECTED, this.onResourceSelected);
      this.listenTo(this.playback, Events$1.Custom.PLAYBACK_AUTHORIZED, this.onPlaybackAuthorized);
      this.listenToOnce(this.container, Events$1.Custom.DAI_RESOURCE_LOADED, this.onDAIResourceLoaded);
    }
  }, {
    key: "onPlaybackAuthorized",
    value: function onPlaybackAuthorized() {
      if (!this.idPlayback.isRestarting && this.isDAIAvailable) return this.setupDAIResource();
      this.setupVideoResource();
    }
  }, {
    key: "setupDAIResource",
    value: function setupDAIResource() {
      Log$1.info(this.name, "Setting up DAI resource. Is DAI resource ready? ".concat(this.DAIResourceReady));

      if (!this.DAIResourceReady) {
        this.listenToOnce(this.container, Events$1.Custom.DAI_RESOURCE_LOADED, this.setupDAIResource);
        this.listenToOnce(this.container, Events$1.Custom.DAI_ERROR, this.onDAIError);
        return;
      }

      this.video.selectedResource.setDAIURL(this.DAIUrlTemplate);
      this.video.selectedResource.enableDAI();
      this.setupVideoResource();
    }
  }, {
    key: "onDAIResourceLoaded",
    value: function onDAIResourceLoaded() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref.url;

      this.DAIResourceReady = true;
      this.DAIUrlTemplate = url;
    }
  }, {
    key: "onDAIError",
    value: function onDAIError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Log$1.warn(this.name, 'Skipping DAI. Loading original resource. DAI Error: ', error);
      this.video.selectedResource.disableDAI();
      this.setupVideoResource();
    }
  }, {
    key: "setupVideoResource",
    value: function setupVideoResource() {
      this.idPlayback.setupVideoResource(this.video.selectedResource.url);
    }
  }, {
    key: "onMetadataLoaded",
    value: function onMetadataLoaded(video) {
      this.video = video;
    }
  }, {
    key: "onResourceLoaded",
    value: function onResourceLoaded(resource) {
      this.resource = new MediaResource(resource, this.options);
      this.selectResource();
    }
  }, {
    key: "selectResource",
    value: function selectResource() {
      this.video.selectedResource = this.resource;
      this.video.isLive && (this.video.transmission = new Transmission(this.video.selectedResource.rawData.resource));
      this.playback.trigger(Events.WM_RESOURCE_SELECTED, this.video, this.resource);
    }
  }, {
    key: "onResourceSelected",
    value: function onResourceSelected(video) {
      this.video = video;
      this.resource && this.resource.cdn && (this.video.cdn = this.resource.cdn);
      if (!this.isResourceValid()) return;
      this.playback.trigger(Events.WM_RESOURCE_READY, this.video);
    }
  }, {
    key: "isResourceValid",
    value: function isResourceValid() {
      if (!Array.isArray(this.resource)) return true;
      this.trigger(Events$1.PLAYBACK_ERROR, Errors.PLAYLIST_LOAD_ERROR);
      return false;
    }
  }, {
    key: "name",
    get: function get() {
      return 'resource';
    }
  }, {
    key: "supportedVersion",
    get: function get() {
      return {
        min: "0.4.21"
      };
    }
  }, {
    key: "playback",
    get: function get() {
      return this.container.playback;
    } // The `enableDAIResourceLoader` option is managed by the DAI plugin

  }, {
    key: "isDAIAvailable",
    get: function get() {
      return this.options.enableDAIResourceLoader;
    }
  }]);

  return Resource;
}(ContainerPlugin);

var Plugins = {
  VideoMetadata: VideoMetadata,
  CDNRouter: CDNRouter,
  Resource: Resource
};

Loader.registerPlayback(IdPlayback);
Object.values(Plugins).forEach(function (plugin) {
  return Loader.registerPlugin(plugin);
});
var Models = {
  Video: Video
};

export { Environment, Errors, Events, Models, Player, Styler, Utils };
